import { IGroupedLinkItems, IGroupedLinks } from '../interfaces';

export const FILTER_BY = { MILITARY_STATUS: 'military-status', STATE: 'state' };

export const PROFILE_NAV_LINKS = [
  { id: 'personal', name: 'Personal' },
  { id: 'military', name: 'Military' },
  { id: 'education', name: 'Education' },
  { id: 'career', name: 'Career' },
];

export const EDUCATION_NAV_LINKS = [
  { id: 'matched-schools', name: 'Matched Schools' },
  { id: 'guides', name: 'Guides' },
  { id: 'scholarship', name: 'Scholarship' },
  { id: 'newsletter', name: 'Newsletter' },
];

export const EMPLOYMENT_NAV_LINKS = [
  { id: 'matching-companies', name: 'Matching Companies' },
  { id: 'career-fairs', name: 'Career Fairs' },
  { id: 'guides', name: 'Guides' },
  { id: 'newsletter', name: 'Newsletter' },
];

export const BENEFIT_NAV_LINKS = [
  { id: 'guides', name: 'Guides' },
  { id: 'forms', name: 'Forms' },
  { id: 'pay', name: 'Pay' },
  { id: 'va-loan', name: 'VA Loan' },
  { id: 'va-disability-claims', name: 'VA Disability Claims' },
  { id: 'insurance', name: 'Insurance' },
  { id: 'newsletter', name: 'Newsletter' },
  { id: 'taxes', name: 'Taxes' },
  { id: 'health', name: 'Health' },
];

export const DISCOUNT_NAV_LINKS = [
  { id: 'seasonal-discounts', name: 'Seasonal Discounts' },
  { id: 'popular-discounts', name: 'Popular Discounts' },
  { id: 'popular-categories', name: 'Popular Categories' },
];

export const DISABILITY_RATING = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export const ICON_CIRCLE_LINK = 'fa-info-circle';

export const ICON_LINK = 'fa-link color-bamboo ';

export const ICON_LINK_CHART = 'fa-link color-dream ';

export const ICON_FILE_COPY = 'fa-copy color-bamboo ';

export const ICON_FILE_ALT = 'fa-file';

export const ICON_DISCOUNT = 'fa-tags color-blue ';

export const ICON_CALENDAR = 'fa-calendar color-citrus-zest ';

export const ICON_CALCULATOR = 'fa-calculator color-blue ';

export const ICON_BALANCE_SCALE = 'fa-balance-scale';

export const ICON_PDF_LINK = 'fa-file-pdf-o color-bamboo';

export const DISCOUNT_LINK = 'https://mymilitarybenefits.com/discounts/';

const EDUCATION_GUIDE_COMMON = [
  {
    name: 'GI Bill',
    url: 'https://collegerecon.com/gi-bill/',
  },
  {
    name: 'Am I Eligible For VA Education Benefits?',
    url: 'https://mymilitarybenefits.com/education/eligible-va-education-benefits/',
  },
];

export const DASHBOARD_WHATS_NEW = [
  {
    name: 'Free Tax Support for Military Members',
    url: 'https://mymilitarybenefits.com/taxes/free-tax-support-for-military-members/',
  },
  {
    name: 'Free Tax Filing for Military',
    url: 'https://mymilitarybenefits.com/finance/free-tax-filing-military/',
  },
  {
    name: "States That Don't Tax Retirement",
    url: 'https://mymilitarybenefits.com/benefits/tax-free-military-retirement-pay-in-these-states/',
  },
  {
    name: 'PCS Moving Resources',
    url: 'https://mymilitarybenefits.com/benefits/pcs-moving-resources-support/',
  },
  {
    name: 'PCS Spring Cleaning',
    url: 'https://mymilitarybenefits.com/finance/spring-cleaning-and-pcs-prep-companies-that-can-help/',
  },
  {
    name: 'Fitness Discounts',
    url: 'https://mymilitarybenefits.com/discounts/fitness-gyms-military-discounts/',
  },
];

export const EDUCATION_GUIDE_ACTIVE_DUTY = [
  {
    name: 'GI Bill',
    url: 'https://collegerecon.com/gi-bill/',
  },
  {
    name: 'Post-9/11 GI Bill',
    url: 'https://collegerecon.com/post-911-gi-bill/',
  },
  {
    name: 'Montgomery GI Bill (Active Duty)',
    url: 'https://collegerecon.com/montgomery-gi-bill/',
  },
  {
    name: 'Tuition Assistance',
    url: 'https://collegerecon.com/tuition-assistance/',
  },
  //[branch] Tuition Assistance
  {
    name: 'Army Tuition Assistance',
    url: 'https://collegerecon.com/army-tuition-assistance/',
    filters: ['Army'],
  },
  {
    name: 'Marine Corps Tuition Assistance',
    url: 'https://collegerecon.com/usmc-tuition-assistance/',
    filters: ['Marine Corps'],
  },
  {
    name: 'Navy Tuition Assistance',
    url: 'https://collegerecon.com/navy-tuition-assistance/',
    filters: ['Navy'],
  },
  {
    name: 'Air Force Tuition Assistance',
    url: 'https://collegerecon.com/air-force-tuition-assistance/',
    filters: ['Air Force'],
  },
  {
    name: 'Coast Guard Tuition Assistance',
    url: 'https://collegerecon.com/uscg-tuition-assistance/',
    filters: ['Coast Guard'],
  },
  {
    name: 'Other Tuition Assistance',
    url: 'https://collegerecon.com/national-guard-reserve-tuition-assistance/',
    filters: ['Space Force', 'N/A', 'Other'],
  },
  //[branch] Tuition Assistance
  //[branch] Education Programs
  {
    name: 'Coast Guard Education Programs',
    url: 'https://collegerecon.com/coast-guard-education/',
    filters: ['Coast Guard'],
  },
  {
    name: 'Air Force Education Programs',
    url: 'https://collegerecon.com/air-force-education-programs/',
    filters: ['Air Force'],
  },
  {
    name: 'Marine Corps Education Programs',
    url: 'https://collegerecon.com/marine-corps-education-programs/',
    filters: ['Marine Corps'],
  },
  {
    name: 'Navy Education Programs',
    url: 'https://collegerecon.com/navy-education-programs/',
    filters: ['Navy'],
  },
  {
    name: 'Army Education Programs',
    url: 'https://collegerecon.com/army-education-programs/',
    filters: ['Army'],
  },
  //[branch] Education Programs
  {
    name: 'States Offering Free College to Veteran Dependents',
    url: 'https://collegerecon.com/states-offering-free-college-veterans-dependents/',
  },
  {
    name: 'Military Friendly Colleges',
    url: 'https://collegerecon.com/military-friendly-colleges/',
  },
  {
    name: 'Best Online Schools For Tuition Assistance',
    url: 'https://collegerecon.com/best-online-schools-military-tuition-assistance/',
  },
  {
    name: 'Schools Fully Covered by Tuition Assistance',
    url: 'https://collegerecon.com/schools-fully-covered-tuition-assistance/',
  },
  {
    name: 'Am I Eligible for VA Education Benefits?',
    url: 'https://mymilitarybenefits.com/education/eligible-va-education-benefits/',
  },
  {
    name: 'Scholarships for Military and Veterans',
    url: 'https://collegerecon.com/military-veteran-scholarships/',
  },
  {
    name: 'Student Loan Guide',
    url: 'https://collegerecon.com/student-loan-guide-military-members-veterans/',
  },
];

export const EDUCATION_GUIDE_GUARD_AND_RESERVE = [
  {
    name: 'GI Bill for Reserve and National Guard Members',
    url: 'https://collegerecon.com/gi-bill-for-reserve-and-national-guard-members/',
  },
  {
    name: 'GI Bill',
    url: 'https://collegerecon.com/gi-bill/',
  },
  {
    name: 'Post-9/11 GI Bill',
    url: 'https://collegerecon.com/post-911-gi-bill/',
  },
  {
    name: 'National Guard Tuition Waivers for Graduate School',
    url: 'https://collegerecon.com/national-guard-tuition-waivers-for-graduate-school/',
  },
  {
    name: 'National Guard & Reserve Education Benefits',
    url: 'https://collegerecon.com/national-guard-reserve-education-benefits/',
  },
  {
    name: 'National Guard & Reserve Tuition Assistance',
    url: 'https://collegerecon.com/national-guard-reserve-tuition-assistance/',
  },
  {
    name: 'Comparing GI Bill Benefits: Active Duty vs Guard & Reserve',
    url: 'https://mymilitarybenefits.com/education/comparing-gi-bill-benefits-active-duty-vs-guard-reserve/',
  },
  {
    name: 'Yellow Ribbon Reintegration Program (YRRP)',
    url: 'https://mymilitarybenefits.com/benefits/national-guard-reserve-reintegration/',
  },
  {
    name: 'Comparing GI Bill Benefits: Active Duty vs Guard & Reserve',
    url: 'https://mymilitarybenefits.com/education/comparing-gi-bill-benefits-active-duty-vs-guard-reserve/',
  },
  {
    name: 'Yellow Ribbon Reintegration Program (YRRP)',
    url: 'https://mymilitarybenefits.com/benefits/national-guard-reserve-reintegration/',
  },
  {
    name: 'VR&E For Guard/Reserve',
    url: 'https://mymilitarybenefits.com/benefits/veteran-readiness-employment-program/',
  },
  {
    name: 'Military Friendly Colleges',
    url: 'https://collegerecon.com/military-friendly-colleges/',
  },
  {
    name: 'Am I Eligible for VA Education Benefits?',
    url: 'https://mymilitarybenefits.com/education/eligible-va-education-benefits/',
  },
  {
    name: 'Scholarships for Military and Veterans',
    url: 'https://collegerecon.com/military-veteran-scholarships/',
  },
  {
    name: 'Student Loan Guide',
    url: 'https://collegerecon.com/student-loan-guide-military-members-veterans/',
  },
];

export const EDUCATION_GUIDE_VETERAN = [
  {
    name: 'GI Bill',
    url: 'https://mymilitarybenefits.com/education/military-gi-bill-benefits-guide/',
  },
  {
    name: 'Post-9/11 GI Bill',
    url: 'https://collegerecon.com/post-911-gi-bill/',
  },
  {
    name: 'In-State Tuition for Veterans',
    url: 'https://collegerecon.com/in-state-tuition-veterans/',
  },
  {
    name: 'Scholarships for Military and Veterans',
    url: 'https://collegerecon.com/military-veteran-scholarships/',
  },
  {
    name: 'Edith Nourse Rogers STEM Scholarship',
    url: 'https://mymilitarybenefits.com/education/edith-nourse-rogers-gi-bill-stem-extension/',
  },
  {
    name: 'States Offering Free College for Veterans and Veterans Dependents',
    url: 'https://collegerecon.com/states-offering-free-college-veterans-dependents/',
  },
  {
    name: 'Military Friendly Colleges',
    url: 'https://collegerecon.com/military-friendly-colleges/',
  },
  {
    name: 'Am I Eligible for VA Education Benefits?',
    url: 'https://mymilitarybenefits.com/education/eligible-va-education-benefits/',
  },
  {
    name: 'Student Loan Guide',
    url: 'https://collegerecon.com/student-loan-guide-military-members-veterans/',
  },
];

export const EDUCATION_GUIDE_SPOUSE = [
  {
    name: 'Montgomery GI Bill (Active Duty)',
    url: 'https://collegerecon.com/montgomery-gi-bill/',
  },
  {
    name: 'Post-9/11 GI Bill enrollment',
    url: 'https://collegerecon.com/post-911-gi-bill/',
  },
  {
    name: 'Military OneSource',
    url: 'https://mymilitarybenefits.com/benefits/military-onesource/',
  },
  {
    name: 'Scholarships for the Military Community',
    url: 'https://collegerecon.com/military-veteran-scholarships/',
  },
  {
    name: 'Student Loan Guide',
    url: 'https://collegerecon.com/student-loan-guide-military-members-veterans/',
  },
  {
    name: 'VA Education Benefits for Surviving Spouses and Dependents',
    url: 'https://collegerecon.com/va-education-benefits-surviving-spouses-dependents/',
  },
  {
    name: 'Fry Scholarship',
    url: 'https://collegerecon.com/john-d-fry-scholarship/',
  },
  {
    name: "States Offering Free Education to Veterans' Dependents",
    url: 'https://collegerecon.com/states-offering-free-college-veterans-dependents/',
  },
  // {
  //   name: 'Post-9/11 GI BIll',
  //   url: 'https://collegerecon.com/post-911-gi-bill/',
  // },
  // {
  //   name: 'Tuition Assistance',
  //   url: '',
  // },
  // {
  //   name: 'Tuition Assistance for Spouses',
  //   url: '',
  // },
  // {
  //   name: 'Military Spouse Student Loan Deferment',
  //   url: 'https://collegerecon.com/military-spouse-student-loan-deferment/',
  // },
  // {
  //   name: "Dependents' Education Assistance (DEA)",
  //   url: 'https://collegerecon.com/va-education-benefits-for-surviving-spouses-and-dependents/',
  // },

  // {
  //   name: 'Accredited MyCAA Schools',
  //   url: 'https://collegerecon.com/mycaa-schools-regionally-nationally-accredited/',
  // },

  // {
  //   name: 'GI Bill Guide for Spouses & Dependents',
  //   url: 'https://collegerecon.com/post-9-11-gi-bill-guide-for-spouses-and-dependents/',
  // },
];

export const EDUCATION_GUIDE_DEPENDENT = [
  {
    name: 'Montgomery GI Bill (Active Duty)',
    url: 'https://collegerecon.com/montgomery-gi-bill/',
  },
  {
    name: 'Post-9/11 GI BIll',
    url: 'https://collegerecon.com/post-911-gi-bill/',
  },
  {
    name: 'Military OneSource',
    url: 'https://mymilitarybenefits.com/benefits/military-onesource/',
  },
  {
    name: 'Scholarships for the Military Community',
    url: 'https://collegerecon.com/military-veteran-scholarships/',
  },
  {
    name: 'Student Loan Guide',
    url: 'https://collegerecon.com/student-loan-guide-military-members-veterans/',
  },
  {
    name: 'VA Education Benefits for Surviving Spouses and Dependents',
    url: 'https://collegerecon.com/va-education-benefits-surviving-spouses-dependents/',
  },
  {
    name: 'Fry Scholarship',
    url: 'https://collegerecon.com/john-d-fry-scholarship/',
  },
  {
    name: "States Offering Free Education to Veterans' Dependents",
    url: 'https://collegerecon.com/states-offering-free-college-veterans-dependents/',
  },
];

export const EDUCATION_GUIDE_DISABLED_VETERAN = [
  {
    name: 'Education Benefits Disabled Vets',
    url: 'https://mymilitarybenefits.com/education/education-benefits-for-disabled-veterans/',
  },
  {
    name: 'GI Bill',
    url: 'https://mymilitarybenefits.com/education/military-gi-bill-benefits-guide/',
  },
  {
    name: 'Veteran Education Benefits (overview)',
    url: 'https://mymilitarybenefits.com/education/veteran-education-benefits-guide/',
  },
];

export const EDUCATION_GUIDE = [
  ...EDUCATION_GUIDE_COMMON,
  {
    name: 'Active Duty Education Guide',
    url: 'https://collegerecon.com/gi-bill/',

    filters: ['Active'],
  },
  {
    name: 'Active Duty GI Bill Application Guide',
    url: 'https://collegerecon.com/how-to-apply-post-9-11-gi-bill-active-duty-veterans/',

    filters: ['Active'],
  },
  {
    name: 'How To Transfer GI Bill Benefits To A Spouse Or Dependent',
    url: 'https://collegerecon.com/how-to-transfer-post-9-11-gi-bill-spouse-dependent/',

    filters: ['Active', 'Spouse', 'Dependent'],
  },
  {
    name: 'Tuition Assistance',
    url: 'https://collegerecon.com/tuition-assistance/',
  },
  {
    name: 'Best Online Schools Approved for Tuition Assistance',
    url: 'https://collegerecon.com/best-online-schools-military-tuition-assistance/',
  },
];

export const EDUCATION_VETERAN_AND_RETIREE: any[] = [
  ...EDUCATION_GUIDE_COMMON,
  {
    name: 'Veterans Education Benefits Guide',
    url: 'https://mymilitarybenefits.com/education/veteran-education-benefits-guide/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'Education Benefits For Disabled Veterans',
    url: 'https://mymilitarybenefits.com/education/education-benefits-for-disabled-veterans/',
    filters: ['Veteran', 'Retiree'],
  },
];

export const EDUCATION_NATIONAL_GUARD_AND_RESERVE: any[] = [
  ...EDUCATION_GUIDE_COMMON,
  {
    name: 'Reserve And Guard Education Benefits Guide',
    url: 'https://collegerecon.com/national-guard-reserve-education-benefits/',
    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'National Guard & Reserve Tuition Assistance',
    url: 'https://collegerecon.com/national-guard-reserve-tuition-assistance/',
    filters: ['Reserve', 'Guard'],
  },
];

export const EDUCATION_SPOUSE_AND_DEPENDENT: any[] = [
  ...EDUCATION_GUIDE_COMMON,
  {
    name: 'Spouse And Dependent GI Bill Guide',
    url: 'https://collegerecon.com/post-9-11-gi-bill-guide-for-spouses-and-dependents/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Spouse And Dependent GI Bill Application',
    url: 'https://collegerecon.com/post-9-11-gi-bill-application-guide-spouses-dependents/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: "VA Form 22-5490 Dependents' Application For VA Education Benefits Step-By-Step Guide",
    url: 'https://collegerecon.com/va-form-22-5490-dependents-application-for-va-education-benefits-step-by-step-guide/',
    filters: ['Spouse', 'Dependent'],
  },
];

export const EMPLOYMENT_GUIDE = [
  {
    name: 'Military Transition Roadmap',
    url: 'https://careerrecon.com/military-transition-roadmap-step-1/',
  },
  {
    name: 'Military Spouses',
    url: 'https://careerrecon.com/military-spouse-employment-guide/',
  },
];

export const BENEFIT_PAY_GUIDES = [
  {
    name: 'Military Pay Charts',
    url: 'https://mymilitarybenefits.com/finance/military-pay-charts-2026/',
    filters: ['Active'],
  },
  {
    name: 'Military Pay Dates',
    url: 'https://collegerecon.com/military-pay-dates/',
    filters: ['Active'],
  },
  {
    name: 'USAA Pay Dates',
    url: 'https://collegerecon.com/usaa-pay-dates/',
    filters: ['Active'],
  },
  {
    name: 'NFCU Pay Dates',
    url: 'https://collegerecon.com/navy-federal-pay-dates/',
    filters: ['Active'],
  },
  {
    name: 'Banks with Early Deposit for Military',
    url: 'https://mymilitarybenefits.com/finance/banks-early-deposits-military/',
    filters: ['Active'],
  },
  {
    name: 'Basic Allowance for Housing (BAH)',
    url: 'https://mymilitarybenefits.com/finance/military-housing-allowances-bah-oha/',
    filters: ['Active'],
  },
  {
    name: 'Military Pay & Allowances',
    url: 'https://mymilitarybenefits.com/finance/military-allowances-guide/',
    filters: ['Active'],
  },
  {
    name: 'Basic Allowance For Subsistence',
    url: 'https://mymilitarybenefits.com/benefits/basic-allowance-subsistence-bas/',
    filters: ['Active'],
  },
  {
    name: 'Basic Needs Allowance',
    url: 'https://mymilitarybenefits.com/finance/basic-needs-allowance-for-low-income-service-members/',
    filters: ['Active'],
  },
  {
    name: 'COLA Allowance',
    url: 'https://mymilitarybenefits.com/benefits/how-cost-of-living-adjustments-cola-work/',
    filters: ['Active'],
  },
  {
    name: 'Special Pay and Allowances',
    url: 'https://mymilitarybenefits.com/finance/special-pays-military-pay/',
    filters: ['Active'],
  },
  {
    name: 'Safer Alternatives to Payday Loans',
    url: 'https://mymilitarybenefits.com/finance/safer-alternatives-payday-loans-military-members/',
    filters: ['Active'],
  },
  {
    name: 'VSafe',
    url: 'https://mymilitarybenefits.com/benefits/department-veterans-affairs-veterans-scam-fraud-evasion/',
    filters: ['Active'],
  },
  {
    name: 'How to Read a Military Pay Chart',
    url: 'https://mymilitarybenefits.com/benefits/how-to-read-a-military-pay-chart/',
    filters: ['Active'],
  },
  {
    name: 'Military Relief Society Loans & Grants for Service Members',
    url: 'https://mymilitarybenefits.com/benefits/military-relief-society-loans-grants-service-members/',
    filters: ['Active'],
  },
  {
    name: 'BAS for Guard/Reserve',
    url: 'https://mymilitarybenefits.com/benefits/guard-and-reserve-bas/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'VSAFE.gov',
    url: 'https://mymilitarybenefits.com/benefits/department-veterans-affairs-veterans-scam-fraud-evasion/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'SGLI for Guard/Reserve',
    url: 'https://mymilitarybenefits.com/finance/eligible-servicemembers-group-life-insurance-sgli/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'VGLI For Guard/Reserve',
    url: 'https://mymilitarybenefits.com/finance/vgli-veterans-group-life-insurance-overview/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Safer Alternatives to Payday Loans for Military Members',
    url: 'https://mymilitarybenefits.com/finance/safer-alternatives-payday-loans-military-members/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'National Guard Pay vs Army Reserves Pay',
    url: 'https://collegerecon.com/national-guard-pay-reserve-pay/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'GI Bill MHA',
    url: 'https://mymilitarybenefits.com/finance/military-housing-allowances-bah-oha/',
    filters: ['Veterans'],
  },
  {
    name: 'VA Disability Pay Rates',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay/',
    filters: ['Veterans'],
  },
  // {
  //   name: 'VA Pension',
  //   url: '',
  //   filters: ['Veterans'],
  // },
  {
    name: 'VA Home Loans',
    url: 'https://mymilitarybenefits.com/finance/va-loans/',
    filters: ['Veteran'],
  },
  {
    name: 'Applying for VA Disability Benefits',
    url: 'https://mymilitarybenefits.com/benefits/applying-va-disability-benefits/',
    filters: ['Veteran'],
  },
  {
    name: 'What Forms Do I Need to Apply for VA Disability?',
    url: 'https://mymilitarybenefits.com/benefits/forms-to-apply-va-disability/',
    filters: ['Veteran'],
  },
  {
    name: 'Disability Compensation: Service-connected disability ratings, monthly payments, Special Monthly Compensation (SMC), and related benefits.',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay/',
    filters: ['Veteran'],
  },
  {
    name: 'VA Loan',
    url: 'https://mymilitarybenefits.com/finance/va-loans/',
    filters: ['Veteran'],
  },
  {
    name: 'Adaptive Sports Grants: Grants for adaptive sports programs for veterans with disabilities.',
    url: 'https://mymilitarybenefits.com/benefits/va-funds-adaptive-sports/',
    filters: ['Veteran'],
  },
  {
    name: 'Specially Adapted Housing (SAH) and Special Housing Adaptation (SHA) Grants',
    url: 'https://mymilitarybenefits.com/benefits/va-specially-adapted-housing-assistive-technology-grant-program/',
    filters: ['Veteran'],
  },
  {
    name: 'VA Homeless Programs',
    url: 'https://mymilitarybenefits.com/benefits/va-programs-for-homeless-veterans/',
    filters: ['Veteran'],
  },
  {
    name: 'Military Pay',
    url: 'https://mymilitarybenefits.com/finance/military-pay-charts-2026/',
    filters: ['Spouse'],
  },
  {
    name: 'How to Read a Military Pay Chart',
    url: 'https://mymilitarybenefits.com/benefits/how-to-read-a-military-pay-chart/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Basic Allowance for Housing (BAH)',
    url: 'https://mymilitarybenefits.com/finance/military-housing-allowances-bah-oha/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'VA Loans for Surviving Spouses',
    url: 'https://mymilitarybenefits.com/finance/va-loans/#VA_Loans_for_Surviving_Spouses',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Safer Alternatives to Payday Loans for Military Members',
    url: 'https://mymilitarybenefits.com/finance/safer-alternatives-payday-loans-military-members/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Dependency and Indemnity Compensation (DIC)',
    url: 'https://mymilitarybenefits.com/benefits/dependency-indemnity-compensation-dic/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Aid & Attendance',
    url: 'https://mymilitarybenefits.com/finance/military-pay-charts-2026/',
    filters: ['Spouse', 'Dependent'],
  },
  // {
  //   name: 'Life Insurance: Veterans\' Group Life Insurance (VGLI), Service-Disabled Veterans Life Insurance (S-DVI), and mortgage protection insurance.',
  //   url: '',
  //   filters: ['Veteran'],
  // },
  // {
  //   name: 'Pension: Veterans Pension, Survivors Pension, Housebound and Aid and Attendance benefits, and related programs.',
  //   url: '',
  //   filters: ['Veteran'],
  // },
  // {
  //   name: 'Other Institutions Pay Dates',
  //   url: 'https://mymilitarybenefits.com/finance/banks-early-deposits-military/',
  // },
];

export const BENEFIT_PAY_RESERVE_ORNATIONAL_GUARD = [
  {
    name: 'Reserve / Guard Pay Charts',
    url: 'https://www.military.com/benefits/military-pay/charts',
  },
  {
    name: 'Reserve / Guard Pay Dates',
    url: 'https://mymilitarybenefits.com/finance/reserve-pay-dat',
  },
];

export const BENEFIT_PAY_RETIREMENT = [
  {
    name: 'Retirement Pay for Guard and Reserve Members',
    url: 'https://mymilitarybenefits.com/finance/retirement-pay-guard-reserve/',
  },
  {
    name: 'Retiree Pay Dates',
    url: 'https://collegerecon.com/military-pay-dates/',
  },
  {
    name: 'Annuitant Pay Dates',
    url: 'https://collegerecon.com/military-pay-dates/',
  },
  {
    name: 'Can the DoD Reduce Your Military Retired Pay?',
    url: 'https://mymilitarybenefits.com/benefits/can-the-dod-reduce-your-military-retired-pay/',
  },
  {
    name: 'Military Retirement Pay and Divorce',
    url: 'https://mymilitarybenefits.com/military-life/military-retirement-pay-and-divorce/',
  },
  {
    name: 'Retired Military and Veterans Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/military-retiree-veteran-benefits-guide/',
  },
  {
    name: 'Military Retirement, Saving, and Investing Options',
    url: 'https://mymilitarybenefits.com/benefits/military-retirement-saving-and-investing-options/',
  },
  {
    name: 'How Military Retirement Pay Works',
    url: 'https://mymilitarybenefits.com/benefits/military-retirement-pay-explained/',
  },
  {
    name: 'Blended Retirement System (BRS): An Overview',
    url: 'https://mymilitarybenefits.com/finance/blended-retirement-system-brs/',
  },
  {
    name: 'Tax-Free Military Retirement Pay In These States',
    url: 'https://mymilitarybenefits.com/benefits/tax-free-military-retirement-pay-in-these-states/',
  },
  {
    name: 'Maximize Your TSP Retirement Fund',
    url: 'https://mymilitarybenefits.com/finance/maximize-tsp-retirement-fund/',
  },
  {
    name: 'Blended Retirement System Continuation Pay: What is it?',
    url: 'https://mymilitarybenefits.com/finance/blended-retirement-system-brs-continuation-pay/',
  },
];

export const BENEFIT_PAY_RETIREES = [
  {
    name: 'Military Retiree Pay Charts',
    url: 'https://www.military.com/benefits/military-pay/charts',
  },
  {
    name: 'Military Retiree Pay Dates',
    url: 'https://collegerecon.com/military-pay-dates/',
  },
  {
    name: 'USAA Pay Dates',
    url: 'https://collegerecon.com/usaa-pay-dates/',
  },
  {
    name: 'NFCU Pay Dates',
    url: 'https://collegerecon.com/navy-federal-pay-dates/',
  },
];

export const BENEFIT_PAY_SPOUSE_OR_DEPENDENT = [
  {
    name: 'Military Pay Charts',
    url: 'https://mymilitarybenefits.com/finance/military-pay-raise-2023/',
  },
  {
    name: 'Military Pay Dates',
    url: 'https://collegerecon.com/military-pay-dates/',
  },
  {
    name: 'USAA Pay Dates',
    url: 'https://collegerecon.com/usaa-pay-dates/',
  },
  {
    name: 'NFCU Pay Dates',
    url: 'https://collegerecon.com/navy-federal-pay-dates/',
  },
  {
    name: 'Other Institutions Pay Dates',
    url: 'https://mymilitarybenefits.com/finance/banks-early-deposits-military/',
  },
];

export const BENEFIT_GUIDE = [
  {
    name: 'Comprehensive Military Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/comprehensive-military-benefits-guide/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Active Duty Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/active-duty-military-benefits-guide/',
    filters: ['Active', 'Guard', 'Reserve'],
  },
  {
    name: 'Veteran & Retiree Benefits Guides',
    url: 'https://mymilitarybenefits.com/benefits/military-retiree-veteran-benefits-guide/',
    filters: ['Veteran', 'Retiree', 'Guard', 'Reserve'],
  },
  {
    name: 'How to File VA Disability Claims',
    url: 'https://mymilitarybenefits.com/benefits/file-va-disability-claims/',
    filters: ['Veteran', 'Retiree', 'Dependent', 'Spouse'],
  },
  {
    name: 'Veteran Education Benefits Guide',
    url: 'https://mymilitarybenefits.com/education/veteran-education-benefits-guide/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'National Guard & Reserve Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/national-guard-reserve-military-benefits-guide/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Spouse and Dependent Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/military-spouses-dependents-benefits-guide/',
    filters: ['Spouse', 'Dependent'],
  },
];

export const BENEFIT_FORMS = [
  {
    name: 'Application for VA Education Benefits',
    updatedDate: 'May 2022',
    relatedTo: 'Education and training',
    fileName: 'Download VA Form 22-1990',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-22-1990-ARE.pdf',
  },
  {
    name: 'Application for Family Member to Use Transferred Benefits',
    updatedDate: 'May 2022',
    relatedTo: 'Education and training, Family member benefits',
    fileName: 'Download VA Form 22-1990e',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-22-1990e-ARE.pdf',
  },
  {
    name: "Dependents' Application for VA Education Benefits",
    updatedDate: 'May 2022',
    relatedTo: 'Education and training, Family member benefits',
    fileName: 'Download VA Form 22-1990e',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-22-5490-ARE.pdf',
  },
  {
    name: 'Education Benefit Entitlement Restoration Request Due to School Closure, Program Suspension or Withdrawal',
    updatedDate: 'May 2022',
    relatedTo: 'Education and training',
    fileName: 'Download VA Form 22-1990e',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-22-0989-ARE.pdf',
  },
  {
    name: 'Request for Change of Program or Place of Training',
    updatedDate: 'July 2022',
    relatedTo: 'Education and training, Service member benefits',
    fileName: 'Download VA Form 22-1995',
    url: 'http://www.vba.va.gov/pubs/forms/VBA-22-1995-ARE.pdf',
  },
  {
    name: 'Application for VA Education Benefits Under the National Call to Service (NCS) Program',
    updatedDate: 'May 2022',
    relatedTo: 'Education and training',
    fileName: 'Download VA Form 22-1990n',
    url: 'http://www.vba.va.gov/pubs/forms/VBA-22-1990n-ARE.pdf',
  },
  {
    name: 'Application for Individualized Tutorial Assistance',
    updatedDate: 'May 2022',
    relatedTo: 'Education and training',
    fileName: 'Download VA Form 22-1990t',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-22-1990t-ARE.pdf',
  },
  {
    name: 'Education/Vocational Counseling Application (Chapter 36)',
    updatedDate: 'June 2022',
    relatedTo: 'Careers and employment, Service member benefits',
    fileName: 'Download VA Form 28-8832',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-28-8832-ARE.pdf',
  },
  {
    name: 'Application for Refund of Educational Contributions (VEAP, Chapter 32, Title 38, U.S.C.)',
    updatedDate: 'March 2022',
    relatedTo: 'Education and training',
    fileName: 'Download VA Form 22-5281',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-22-5281-ARE.pdf',
  },
  {
    name: 'Education Debt Reduction Program (EDRP) Application - Fillable',
    updatedDate: 'December 2022',
    relatedTo: 'VHA',
    fileName: 'Download VA Form 10-0394',
    url: 'https://www.va.gov/vaforms/medical/pdf/vha-10-0491j-fill%20(Deferment).pdf',
  },
  {
    name: 'Authorization to Disclose Personal Information to a Third Party - Education Benefits (Fillable)',
    updatedDate: 'September 2022',
    relatedTo: 'VBA',
    fileName: 'Download VA Form 22-10278',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-22-10278-ARE.pdf',
  },
  {
    name: 'Intent to File a Claim for Compensation and/or Pension, or Survivors Pension and/or DIC',
    updatedDate: 'December 2022',
    relatedTo: 'Disability, Family member benefits, Pension',
    fileName: 'Download VA Form 21-0966',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-21-0966-ARE.pdf',
  },
  {
    name: 'Application for Disability Compensation and Related Compensation Benefits',
    updatedDate: 'November 2022',
    relatedTo: 'Disability',
    fileName: 'Download VA Form 21-526EZ (PDF) ',
    url: 'http://www.vba.va.gov/pubs/forms/VBA-21-526EZ-ARE.pdf',
  },
  {
    name: 'Application for DIC, Survivors Pension, and/or Accrued Benefits',
    updatedDate: 'December 2022',
    relatedTo: 'Disability, Family member benefits, Pension',
    fileName: 'Download VA Form 21P-534EZ',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-21P-534EZ-ARE.pdf',
  },
  {
    name: 'Request for Employment Information in Connection with Claim for Disability Benefits ',
    updatedDate: 'June 2022',
    relatedTo: 'Education and training',
    fileName: 'Get VA Form 21-4192 to download',
    url: 'https://www.vba.va.gov/pubs/forms/VBA-21-4192-ARE.pdf',
  },
  {
    name: "VA Form 21-8940 Veteran's Application for Increased Compensation Based on Unemployability",
    updatedDate: 'November 2022',
    relatedTo: '',
    fileName: 'Download VA Form 21-8940 (PDF)',
    url: 'http://www.vba.va.gov/pubs/forms/VBA-21-8940-ARE.pdf',
  },
  {
    name: 'VA Form 28-1900 Application for Veteran Readiness and Employment for Claimants with Service-Connected Disabilities',
    updatedDate: 'December 2022',
    relatedTo: '',
    fileName: 'Download VA Form 28-1900 (PDF)',
    url: 'http://www.vba.va.gov/pubs/forms/VBA-28-1900-ARE.pdf',
  },
  {
    name: 'VA Form 21-0304 Application for Benefits for Certain Children with Disabilities Born of Vietnam and Certain Korea Service Veterans.',
    updatedDate: 'June 2022 ',
    relatedTo: '',
    fileName: 'Get VA Form 21-0304 to download',
    url: 'https://www.va.gov/find-forms/about-form-21-0304',
  },
];

export const BENEFIT_VA_LOAN = [
  // { name: '$0 DOWN on most home purchases', url: '', icon: ICON_LINK },
  // {
  //   name: 'No Private Mortgage Insurance (PMI) ',
  //   url: '',
  //
  // },
  // {
  //   name: 'Certain closing costs are limited by the VA ',
  //   url: '',
  //
  // },
  // {
  //   name: 'VA Home Loan Purchase & Refinance Guide',
  //   url: 'https://mymilitarybenefits.com/finance/va-loans/',
  // },
  // {
  //   name: 'Free VA Loan Consultation',
  //   url: 'https://mymilitarybenefits.com/veterans-first/',
  // },
  // {
  //   name: 'VA Loan Limits',
  //   url: 'https://mymilitarybenefits.com/finance/va-loan-limits-2022/',
  // },
  // {
  //   name: 'BAH Calculator',
  //   url: 'https://mymilitarybenefits.com/benefits/military-housing-allowances-bah-and-oha/',
  //   icon: ICON_CALCULATOR,
  // },
  {
    name: 'VA Home Loan Benefits',
    url: 'https://mymilitarybenefits.com/finance/va-loans/',
    filters: ['Active'],
  },
  {
    name: 'Getting Started with VA Loan Benefits',
    url: 'https://mymilitarybenefits.com/benefits/getting-started-with-va-loan-benefits/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'VA Home Loans for Guard & Reserve',
    url: 'https://mymilitarybenefits.com/benefits/national-guard-va-home-loans/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'VA Loan: Facts and Fiction',
    url: 'https://mymilitarybenefits.com/finance/va-home-loans-fact-fiction/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Loan: Q & A',
    url: 'https://mymilitarybenefits.com/finance/questions-answers-va-home-loans/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Loans: What You Need to Know',
    url: 'https://mymilitarybenefits.com/finance/va-loans-what-you-need-know/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Loan Refinance: What You Need to Know',
    url: 'https://mymilitarybenefits.com/benefits/what-to-know-about-va-refinance-loans/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Loan Cash-Out Refinancing: Good or Bad Idea',
    url: 'https://mymilitarybenefits.com/finance/va-cash-out-refinancing-loans/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Home Loan vs Other Mortgage Options',
    url: 'https://mymilitarybenefits.com/finance/va-home-loans-compared-to-other-mortgage-options/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Announces Tax-Deductible VA Loan Funding Fee',
    url: 'https://mymilitarybenefits.com/va-loan/va-announces-tax-deductible-va-loan-funding-fee/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Loans for Mobile and Manufactured Homes',
    url: 'https://mymilitarybenefits.com/finance/va-loan-mobile-homes-manufactured-housing/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'Why Credit Scores Matter',
    url: 'https://mymilitarybenefits.com/finance/va-loans-why-credit-scores-matter/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'Down Payments and Gift Funds',
    url: 'https://mymilitarybenefits.com/finance/va-loans-down-payments-gift-funds/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'FHA vs VA Loans: Which Is Better',
    url: 'https://mymilitarybenefits.com/finance/va-loans-versus-fha-mortgages/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Loans and the Appraisal Process',
    url: 'https://mymilitarybenefits.com/finance/va-loans-appraisal-process/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'Investment Properties and Deployments',
    url: 'https://mymilitarybenefits.com/finance/va-loans-investment-properties-deployments/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'BAH Calculator',
    url: 'https://mymilitarybenefits.com/finance/military-housing-allowances-bah-oha/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Foreclosure Avoidance Program',
    url: 'https://mymilitarybenefits.com/benefits/va-announces-foreclosure-avoidance-program/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran'],
  },
  {
    name: 'VA Loans for Surviving Spouses',
    url: 'https://mymilitarybenefits.com/finance/va-loans/#VA_Loans_for_Surviving_Spouses',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'VA Loan COE',
    url: 'https://mymilitarybenefits.com/finance/the-va-loan-certificate-of-eligibility/',
    filters: ['Spouse', 'Dependent'],
  },
];

export const BENEFIT_VA_DISABILITY_CLAIM = [
  {
    name: 'What Forms Do I Need to Apply for VA Disability?',
    url: 'https://mymilitarybenefits.com/benefits/forms-to-apply-va-disability/',
  },
  {
    name: 'How to File for a VA Disability Increase',
    url: 'https://mymilitarybenefits.com/benefits/how-to-file-for-a-va-disability-increase/',
  },
  {
    name: 'VA Claims',
    url: 'https://mymilitarybenefits.com/claims-help/',
  },
];

export const BENEFIT_NEWSLETTER = [
  {
    image: '/assets/img/careerrecon-logo.svg',
    url: 'https://careerrecon.com/careerrecon-newsletter/',
    alt: 'career recon logo',
    buttonName: 'subscribe',
    type: 'image',
  },
  {
    image: '/assets/img/logo.1643a230.svg',
    url: 'https://collegerecon.com/collegerecon-newsletter/',
    alt: 'college recon logo',
    buttonName: 'subscribe',
    type: 'image',
  },
  {
    image: '/assets/img/MyMilitaryBenefits.png',
    alt: 'military benefit logo',
    type: 'image',
  },
  {
    image: '',
    url: 'https://mymilitarybenefits.com/mmb-newsletter/',
    alt: 'military benefit logo',
    buttonName: 'subscribe',
    type: 'link',
    text: 'News and Benefits',
  },
  {
    image: '/assets/img/MyMilitaryBenefits.png',
    url: 'https://mymilitarybenefits.com/discounts-newsletter/',
    alt: 'military benefit logo',
    buttonName: 'subscribe',
    type: 'link',
    text: 'Deals and Discounts',
  },
];

// task_1040: taxes links per the client's profiles spreadsheet (Taxes sheet).
// 'Disabled Veteran' is its own user type in the matrix — a Veteran with a VA
// disability rating > 0 matches that column instead of 'Veteran'
// (resolved in benefits.component setTaxValues).
export const BENEFIT_TAXES = [
  {
    name: 'ABLE Savings Accounts & Tax Breaks',
    url: 'https://mymilitarybenefits.com/benefits/1-million-veterans-get-access-to-able-savings-accounts-tax-breaks/',
    filters: ['Veteran', 'Retiree', 'Spouse'],
  },
  {
    name: 'Tax-Deductible VA Loan Funding Fee',
    url: 'https://mymilitarybenefits.com/va-loan/va-announces-tax-deductible-va-loan-funding-fee/',
    filters: ['Active', 'Veteran', 'Retiree', 'Spouse'],
  },
  {
    name: 'Federal Tax Benefits for Disabled Veterans',
    url: 'https://mymilitarybenefits.com/benefits/federal-tax-benefits-for-disabled-veterans/',
    filters: ['Veteran', 'Disabled Veteran'],
  },
  {
    name: 'Is the GI Bill Taxable?',
    url: 'https://mymilitarybenefits.com/education/is-the-gi-bill-taxable/',
    filters: ['Active', 'Veteran', 'Retiree', 'Spouse', 'Dependent'],
  },
  {
    name: 'Veteran Tax Benefits',
    url: 'https://mymilitarybenefits.com/finance/veteran-tax-benefits/',
    filters: ['Veteran', 'Retiree', 'Spouse', 'Dependent', 'Disabled Veteran'],
  },
  {
    name: 'How to Apply for Armed Forces Tax Benefits',
    url: 'https://mymilitarybenefits.com/finance/how-apply-armed-forces-tax-benefits/',
    filters: ['Active', 'Spouse'],
  },
  {
    name: 'Free Tax Support for Military Members',
    url: 'https://mymilitarybenefits.com/benefits/free-tax-support-for-military-members/',
    filters: ['Active', 'Spouse'],
  },
  {
    name: 'Tax-Free Military Retirement Pay in These States',
    url: 'https://mymilitarybenefits.com/benefits/tax-free-military-retirement-pay-in-these-states/',
    filters: ['Active', 'Veteran', 'Retiree', 'Spouse', 'Disabled Veteran'],
  },
  {
    name: 'Basic Training & Taxes',
    url: 'https://mymilitarybenefits.com/finance/basic-training-taxes-military/',
    filters: ['Active', 'Spouse'],
  },
  {
    name: 'Free Tax Filing for Military',
    url: 'https://mymilitarybenefits.com/finance/free-tax-filing-military/',
    filters: ['Active', 'Veteran', 'Retiree', 'Spouse', 'Dependent', 'Disabled Veteran'],
  },
];

export const BENEFIT_HEALTHS = [
  // Active
  {
    name: 'TRICARE',
    url: 'https://mymilitarybenefits.com/benefits/tricare-guide/',
    filters: ['Active', 'Other'],
  },
  {
    name: 'Dental Care (Individual)',
    url: 'https://mymilitarybenefits.com/benefits/tricare-fedvip-dental-and-vision-rates/',
    filters: ['Active'],
  },
  {
    name: 'VA Health Chat app',
    url: 'https://mymilitarybenefits.com/benefits/va-health-chat-app-connects-veterans-with-non-emergency-medical-help/',
    filters: ['Active', 'Reserve', 'Guard', 'Veteran', 'Spouse'],
  },
  {
    name: 'Veteran Crisis Line',
    url: 'https://mymilitarybenefits.com/resources-2/va-updates-veteran-crisis-hotline/',
    filters: ['Active'],
  },
  {
    name: 'TRICARE for Spouses',
    url: 'https://mymilitarybenefits.com/benefits/tricare-spouses-dependents/',
    filters: ['Active', 'Reserve', 'Guard', 'Spouse'],
  },
  {
    name: 'TRICARE Guide',
    url: 'https://mymilitarybenefits.com/benefits/tricare-guide/',
    filters: ['Active', 'Reserve', 'Guard', 'Spouse', 'Dependent'],
  },
  {
    name: 'TRICARE Prime vs TRICARE Select',
    url: 'https://mymilitarybenefits.com/benefits/tricare-prime-versus-tricare-select/',
    filters: ['Active'],
  },
  {
    name: 'TRICARE for Life',
    url: 'https://mymilitarybenefits.com/benefits/tricare-for-life/',
    filters: ['Active', 'Reserve', 'Guard', 'Spouse', 'Dependent'],
  },
  {
    name: 'TRICARE for National Guard & Reserve',
    url: 'https://mymilitarybenefits.com/benefits/tricare-national-guard-reserve/',
    filters: ['Active', 'Spouse', 'Dependent'],
  },
  // Active

  // Guard & Reserve
  {
    name: 'TRICARE for Guard & Reserve',
    url: 'https://mymilitarybenefits.com/benefits/tricare-for-guard-and-reserve-members/',
    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'TRICARE Reserve Select',
    url: 'https://mymilitarybenefits.com/benefits/tricare-national-guard-reserve/',
    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'TRICARE',
    url: 'https://mymilitarybenefits.com/benefits/tricare-guide/',
    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Veteran Crisis Line',
    url: 'https://mymilitarybenefits.com/resources-2/va-updates-veteran-crisis-hotline/',
    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'TRICARE Prime vs TRICARE Select',
    url: 'https://mymilitarybenefits.com/benefits/tricare-prime-versus-tricare-select/',
    filters: ['Reserve', 'Guard', 'Spouse', 'Dependent'],
  },
  // Guard & Reserve

  //Veterans
  {
    name: 'Dental Insurance Program (VADIP)',
    url: 'https://mymilitarybenefits.com/benefits/va-dental-insurance-vadip/',
    filters: ['Veteran'],
  },
  {
    name: 'Dental Care (Individual)',
    url: 'https://mymilitarybenefits.com/benefits/tricare-fedvip-dental-and-vision-rates/',
    filters: ['Veteran', 'Reserve', 'Guard', 'Dependent'],
  },
  {
    name: 'Medical care (individual)',
    url: 'https://mymilitarybenefits.com/benefits/tricare-guide/',
    filters: ['Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'TRICARE',
    url: 'https://mymilitarybenefits.com/benefits/tricare-guide/',
    filters: ['Veteran'],
  },
  {
    name: 'PACT Act-related benefits',
    url: 'https://mymilitarybenefits.com/benefits/pact-act-changes-va-benefits/',
    filters: ['Veteran'],
  },
  {
    name: 'Services for Blind and Deaf Veterans',
    url: 'https://mymilitarybenefits.com/benefits/va-non-va-services-blind-deaf-veterans/',
    filters: ['Veteran'],
  },
  {
    name: 'Veterans Crisis Hotline',
    url: 'https://mymilitarybenefits.com/resources-2/va-updates-veteran-crisis-hotline/',
    filters: ['Veteran'],
  },
  {
    name: 'Q & A: Mental Health Services',
    url: 'https://mymilitarybenefits.com/benefits/va-mental-health-services-questions-and-answers/',
    filters: ['Veteran'],
  },
  {
    name: 'VA Primary Care',
    url: 'https://mymilitarybenefits.com/benefits/va-primary-care/',
    filters: ['Veteran'],
  },
  {
    name: 'Mobile Vet Centers',
    url: 'https://mymilitarybenefits.com/benefits/va-mobile-vet-centers/',
    filters: ['Veteran'],
  },
  {
    name: 'Women Veterans and VA Healthcare',
    url: 'https://mymilitarybenefits.com/benefits/what-women-veterans-should-know-about-va-healthcare/',
    filters: ['Veteran'],
  },
  {
    name: 'Dental Care Benefits',
    url: 'https://mymilitarybenefits.com/benefits/va-dental-care-benefits/',
    filters: ['Veteran'],
  },
  {
    name: 'Veteran Crisis Line',
    url: 'https://mymilitarybenefits.com/resources-2/va-updates-veteran-crisis-hotline/',
    filters: ['Veteran'],
  },
  {
    name: 'Blind Rehabilitation',
    url: 'https://mymilitarybenefits.com/benefits/career-resources-blind-veterans-visually-impaired-veterans/',
    filters: ['Veteran'],
  },
  {
    name: 'Dental Insurance Program (VADIP)',
    url: 'https://mymilitarybenefits.com/benefits/va-dental-insurance-vadip/',
    filters: ['Veteran'],
  },
  {
    name: 'VA Specialty Care',
    url: 'https://mymilitarybenefits.com/benefits/va-specialty-care-services/',
    filters: ['Veteran'],
  },
  {
    name: 'VA Health Connect',
    url: 'https://mymilitarybenefits.com/benefits/va-health-chat-app-connects-veterans-with-non-emergency-medical-help/',
    filters: ['Veteran'],
  },
  {
    name: 'Public Health Programs',
    url: 'https://mymilitarybenefits.com/benefits/pact-act-expanded-va-benefits-for-surviving-spouses-dependents/ and https://mymilitarybenefits.com/benefits/how-to-get-a-va-toxic-exposure-screening/',
    filters: ['Veteran'],
  },
  {
    name: 'Geriatrics and Extended Care',
    url: 'https://mymilitarybenefits.com/benefits/va-geriatrics-and-extended-care-services/',
    filters: ['Veteran'],
  },
  //Veterans

  //Retirees
  {
    name: 'Military Retirement and TRICARE',
    url: 'https://mymilitarybenefits.com/benefits/military-retirement-tricare/',
    filters: ['Retiree'],
  },
  {
    name: 'TRICARE for Active Duty Military Retirees',
    url: '',
    filters: ['Retiree'],
  },
  //Retirees

  //Spouses & Dependents
  {
    name: 'CHAMPVA',
    url: 'https://mymilitarybenefits.com/benefits/va-health-benefits-military-spouses-dependents/ ',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Caregiver Support Program',
    url: 'https://mymilitarybenefits.com/benefits/va-health-benefits-military-spouses-dependents/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Camp Lejeune Family Member Program',
    url: 'https://mymilitarybenefits.com/benefits/camp-lejeune-family-member-program/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Respite care',
    url: 'https://mymilitarybenefits.com/benefits/va-respite-care-support-for-disabled-veteran-caregivers/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Program of General Caregiver Support Services',
    url: 'https://mymilitarybenefits.com/benefits/what-to-know-about-the-va-caregiver-support-program/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Mental health services',
    url: 'https://mymilitarybenefits.com/benefits/dod-offers-mental-health-support-for-transitioning-troops/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Dental care (indiviudual)',
    url: 'https://mymilitarybenefits.com/benefits/tricare-fedvip-dental-and-vision-rates/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Healthcare Flexible Spending Accounts',
    url: 'https://mymilitarybenefits.com/benefits/healthcare-flexible-spending-accounts-active-duty',
    filters: ['Active', 'Spouse', 'Dependent', 'Reserve', 'Guard', 'Veteran'],
  },
  {
    name: 'TRICARE',
    url: 'https://mymilitarybenefits.com/benefits/tricare-guide/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Veteran Crisis Line',
    url: 'https://mymilitarybenefits.com/resources-2/va-updates-veteran-crisis-hotline/',
    filters: ['Spouse'],
  },
  {
    name: 'TRICARE for Dependents',
    url: 'https://mymilitarybenefits.com/benefits/tricare-spouses-dependents/',
    filters: ['Dependent'],
  },

  // {
  //   name: 'TRICARE Basics',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-basics/',

  //   filters: ['Active'],
  // },
  // {
  //   name: 'TRICARE for Active Duty Service Members',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-active-duty-service-members/',

  //   filters: ['Active'],
  // },
  // {
  //   name: 'TRICARE Qualifying Life Events',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-qualifying-life-events-health-insurance/',

  //   filters: ['Active', 'Other'],
  // },
  // {
  //   name: 'Using Other Health Insurance Besides TRICARE',
  //   url: 'https://mymilitarybenefits.com/benefits/using-other-health-insurance-besides-tricare/',

  //   filters: ['Active'],
  // },
  // {
  //   name: 'Military Life Insurance and End-of-Life Planning',
  //   url: 'https://mymilitarybenefits.com/military-life/military-life-insurance-and-end-of-life-planning/',

  //   filters: ['Active'],
  // },
  // {
  //   name: 'Private Life Insurance for the Military Community',
  //   url: 'https://mymilitarybenefits.com/finance/life-insurance-military-veterans/',

  //   filters: ['Active'],
  // },
  // {
  //   name: 'The PACT Act and Your VA Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/pact-act-changes-va-benefits/',

  //   filters: ['Active'],
  // },
  // {
  //   name: 'TRICARE and Non-Covered Services',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-non-covered-services/',

  //   filters: ['Active'],
  // },
  // {
  //   name: 'TRICARE, FEDVIP Dental and Vision Rates 2023',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-fedvip-dental-vision-rates-2023/',

  //   filters: ['Active'],
  // },
  // {
  //   name: 'Using Health Insurance Other Than TRICARE',
  //   url: 'https://mymilitarybenefits.com/benefits/using-other-health-insurance-besides-tricare/',

  //   filters: ['Other'],
  // },
  // {
  //   name: 'VA Health Benefits for Spouses & Dependents',
  //   url: 'https://mymilitarybenefits.com/benefits/va-health-benefits-military-spouses-dependents/',

  //   filters: ['Other'],
  // },
  // {
  //   name: 'TRICARE Prime vs Select',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-prime-versus-tricare-select/',

  //   filters: ['Other'],
  // },
  // {
  //   name: 'TRICARE: Guide to TRICARE',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-overview/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'What TRICARE Covers',
  //   url: 'https://mymilitarybenefits.com/benefits/what-tricare-covers/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'How Does VA Healthcare Compare to Non-VA Healthcare?',
  //   url: 'https://mymilitarybenefits.com/benefits/va-healthcare-compare-non-va/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'How to Get a VA Toxic Exposure Screening',
  //   url: 'https://mymilitarybenefits.com/benefits/how-to-get-a-va-toxic-exposure-screening/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'VA Offers Free Mental Health Crisis Care to Veterans',
  //   url: 'https://mymilitarybenefits.com/benefits/va-offers-free-mental-health-crisis-care-to-veterans/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'Using a Flexible Spending Account with TRICARE',
  //   url: 'https://mymilitarybenefits.com/benefits/using-flexible-spending-account-tricare/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'Expiration Dates for VA Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/expiration-dates-for-va-benefits/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'VA Disability Benefits for COVID-19',
  //   url: 'https://mymilitarybenefits.com/benefits/va-disability-benefits-for-covid-19/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'TRICARE for Active Duty Military Retirees',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-active-duty-military-retirees/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'Veterans Asbestos Exposure and VA Policy',
  //   url: 'https://mymilitarybenefits.com/benefits/veterans-asbestos-exposure-and-va-policy/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'How to File VA Disability Claims',
  //   url: 'https://mymilitarybenefits.com/benefits/file-va-disability-claims/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'DoD Sexual Assault Prevention and Response',
  //   url: 'https://mymilitarybenefits.com/news/dod-sexual-assault-prevention-response/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'Telemedicine Benefits for Military and Veterans',
  //   url: 'https://mymilitarybenefits.com/benefits/telemedicine-military-veterans/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'VA Benefits for Disabilities Appearing Within a Year After Discharge',
  //   url: 'https://mymilitarybenefits.com/benefits/va-benefits-disabilities-appearing-year-after-discharge/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'How to Avoid Mistakes When Claiming VA Disability Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/how-to-avoid-mistakes-when-claiming-va-disability-benefits/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'Make The Connection: Promoting Mental Health',
  //   url: 'https://mymilitarybenefits.com/benefits/make-the-connection-promoting-mental-health/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'Mental Health Resources for Veterans',
  //   url: 'https://mymilitarybenefits.com/benefits/veteran-mental-health-resources/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'Military Discounts on Health & Wellness',
  //   url: 'https://mymilitarybenefits.com/discounts/health-wellness-military-discounts/',

  //   filters: ['Veteran', 'Retiree'],
  // },
  // {
  //   name: 'TRICARE for Spouses and Dependents',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-spouses-dependents/',

  //   filters: ['Spouse', 'Dependent'],
  // },
  // {
  //   name: 'VA Benefits for Military Spouses and Dependents',
  //   url: 'https://mymilitarybenefits.com/benefits/va-health-benefits-military-spouses-dependents/',

  //   filters: ['Spouse', 'Dependent'],
  // },
  // {
  //   name: 'VA Benefits for Family Members, Survivors, and Family Caregivers',
  //   url: 'https://mymilitarybenefits.com/benefits/va-benefits-family-members-survivors-caregivers/',

  //   filters: ['Spouse', 'Dependent'],
  // },
  // {
  //   name: 'VA Support and Resources for Caregivers',
  //   url: 'https://mymilitarybenefits.com/benefits/va-caregivers-support-resources/',

  //   filters: ['Spouse', 'Dependent'],
  // },
  // {
  //   name: 'The VA Program of Comprehensive Assistance for Family Caregivers',
  //   url: 'https://mymilitarybenefits.com/benefits/the-va-program-of-comprehensive-assistance-for-family-caregivers/',

  //   filters: ['Spouse', 'Dependent'],
  // },
  // {
  //   name: 'TRICARE for National Guard and Reserve Members',
  //   url: 'https://mymilitarybenefits.com/benefits/tricare-national-guard-reserve/',

  //   filters: ['Guard', 'Reserve'],
  // },
  // {
  //   name: 'Healthcare When Going from Active Duty to National Guard',
  //   url: 'https://mymilitarybenefits.com/benefits/healthcare-active-guard-reserve/',

  //   filters: ['Guard', 'Reserve'],
  // },
];

export const BENEFIT_OTHERS = [
  // {
  //   name: 'On-Base Childcare',
  //   url: '',
  //   filters: ['Active'],
  // },

  {
    name: 'Childcare',
    url: 'https://mymilitarybenefits.com/benefits/military-child-care-basics/',
    filters: ['Active'],
  },
  {
    name: 'Space-A Travel',
    url: 'https://mymilitarybenefits.com/benefits/space-a-travel/',
    filters: ['Active'],
  },
  // {
  //   name: 'Military Benefits Offered During Basic Training',
  //   url: 'https://mymilitarybenefits.com/benefits/military-benefits-offered-during-basic-training/',
  //   filters: ['Active'],
  // },
  {
    name: 'Benefits Delivery at Discharge (BDD)',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay-benefits-delivery-discharge-program/',
    filters: ['Active'],
  },
  // {
  //   name: 'Accelerated VA Death Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/accelerated-va-death-benefits/',
  //   filters: ['Active', 'Veteran', 'Spouse', 'Dependent'],
  // },
  // {
  //   name: 'Burial Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/va-burial-benefits/',
  //   filters: ['Active', 'Veteran', 'Spouse', 'Dependent'],
  // },
  // {
  //   name: 'Burial Benefits for Spouses',
  //   url: 'https://mymilitarybenefits.com/benefits/military-spouse-burial-benefits/',
  //   filters: ['Active'],
  // },
  {
    name: 'Military Spouse and Dependents Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/military-spouses-dependents-benefits-guide/',
    filters: ['Active'],
  },
  {
    name: 'Aid & Attendance Family Caregiver Benefits',
    url: 'https://mymilitarybenefits.com/benefits/aid-attendance-housebound-benefits/',
    filters: ['Active'],
  },

  {
    name: 'VA Burial Benefits Guard/Reserve',
    url: 'https://mymilitarybenefits.com/benefits/va-burial-benefits/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Burial Benefits Guard/Reserve',
    url: 'https://mymilitarybenefits.com/benefits/guard-and-reserve-military-burial-benefits/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Burial and Memorial Benefits',
    url: 'https://mymilitarybenefits.com/benefits/va-burial-benefits/',
    filters: ['Veteran'],
  },
  {
    name: 'National Cemetery Pre-Need Eligibility Determination',
    url: 'https://mymilitarybenefits.com/benefits/va-cemetery-pre-need-determination-program/',
    filters: ['Veteran'],
  },
  {
    name: 'Veteran Justice Outreach (VJO) Program',
    url: 'https://mymilitarybenefits.com/benefits/veteran-justice-outreach-program/',
    filters: ['Veteran'],
  },
  {
    name: 'Military Spouse Burial Benefits',
    url: 'https://mymilitarybenefits.com/benefits/military-spouse-burial-benefits/',
    filters: ['Spouse', 'Dependent'],
  },
];

export const BENEFIT_OTHERS_BASIC_TRAINING = [
  {
    name: 'Military Benefits Offered During Basic Training',
    url: 'https://mymilitarybenefits.com/benefits/military-benefits-offered-during-basic-training/',
    filters: ['Active'],
  },
];
export const BENEFIT_OTHERS_DEATH_AND_BURIAL = [
  {
    name: 'Accelerated VA Death Benefits',
    url: 'https://mymilitarybenefits.com/benefits/accelerated-va-death-benefits/',
    filters: ['Active', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'Burial Benefits',
    url: 'https://mymilitarybenefits.com/benefits/va-burial-benefits/',
    filters: ['Active', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'Burial Benefits for Spouses',
    url: 'https://mymilitarybenefits.com/benefits/military-spouse-burial-benefits/',
    filters: ['Active'],
  },
];

export const BENEFIT_DISABILITY_HEALTHS = [
  // {
  //   name: 'Disabled Veteran Benefits Guide',
  //   url: 'https://mymilitarybenefits.com/benefits/disabled-veteran-benefits-guide/',
  // },
  // {
  //   name: 'VA Benefits for Disabilities Appearing Within a Year After Discharge',
  //   url: 'https://mymilitarybenefits.com/benefits/va-benefits-disabilities-appearing-year-after-discharge/',
  // },
  // {
  //   name: 'How to Avoid Mistakes When Claiming VA Disability Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/how-to-avoid-mistakes-when-claiming-va-disability-benefits/',
  // },
  {
    name: 'Camp Lejeune Family Member Program',
    url: 'https://mymilitarybenefits.com/benefits/camp-lejeune-family-member-program/',
  },
  {
    name: 'Respite care',
    url: 'https://mymilitarybenefits.com/benefits/va-respite-care-support-for-disabled-veteran-caregivers/',
  },
  {
    name: 'Program of General Caregiver Support Services',
    url: 'https://mymilitarybenefits.com/benefits/what-to-know-about-the-va-caregiver-support-program/',
  },
  {
    name: 'Mental health services',
    url: 'https://mymilitarybenefits.com/benefits/dod-offers-mental-health-support-for-transitioning-troops/',
  },
  {
    name: 'Aid & Attendance Family Caregiver Benefits',
    url: 'https://mymilitarybenefits.com/benefits/aid-attendance-housebound-benefits/',
  },
  {
    name: 'VA Health Chat app',
    url: 'https://mymilitarybenefits.com/benefits/va-health-chat-app-connects-veterans-with-non-emergency-medical-help/',
  },
  {
    name: 'Veteran Crisis Line',
    url: 'https://mymilitarybenefits.com/resources-2/va-updates-veteran-crisis-hotline/',
  },
  {
    name: 'TRICARE for Spouses',
    url: 'https://mymilitarybenefits.com/benefits/tricare-spouses-dependents/',
  },
];

export const BENEFIT_WOMEN_HEALTHS = [
  {
    name: 'VA Healthcare Benefits for Women Veterans: Birth Control',
    url: 'https://mymilitarybenefits.com/benefits/va-healthcare-benefits-for-women-veterans-birth-control/',
  },
];

export const BENEFIT_LGBTQ_HEALTHS = [
  {
    name: 'VA Resources for LGTBQ Veterans',
    url: 'https://mymilitarybenefits.com/benefits/department-of-veterans-affairs-resources-for-lgbtq-veterans/',
  },
];

export const BENEFIT_INSURANCE = [
  {
    name: 'Life Insurance',
    url: 'https://mymilitarybenefits.com/finance/life-insurance-military-veterans/',
    filters: ['Active'],
  },
  {
    name: 'SGLI',
    url: 'https://mymilitarybenefits.com/finance/who-is-eligible-for-servicemembers-group-life-insurance-sgli/',
    filters: ['Active'],
  },
  {
    name: 'SGLI for Guard/Reserve',
    url: 'https://mymilitarybenefits.com/finance/eligible-servicemembers-group-life-insurance-sgli/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'VGLI For Guard/Reserve',
    url: 'https://mymilitarybenefits.com/finance/vgli-veterans-group-life-insurance-overview/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Reserve Component Survivor Benefit Plan',
    url: 'https://mymilitarybenefits.com/benefits/reserve-component-survivor-benefit-plan-rcsbp/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Life Insurance Guide for the Military',
    url: 'https://mymilitarybenefits.com/finance/life-insurance-military-veterans/',
    filters: ['Veteran'],
  },
  {
    name: 'Military Life Insurance and End of Life Planning',
    url: 'https://mymilitarybenefits.com/finance/military-life-insurance-end-of-life-planning/',
    filters: ['Veteran'],
  },
  {
    name: 'Tips for Buying Life Insurance',
    url: 'https://mymilitarybenefits.com/finance/tips-for-buying-life-insurance/',
    filters: ['Veteran'],
  },
  {
    name: 'Can I Get Life Insurance with PTSD?',
    url: 'https://mymilitarybenefits.com/finance/can-i-get-life-insurance-with-ptsd/',
    filters: ['Veteran'],
  },
  {
    name: 'Calculating Life Expectancy',
    url: 'https://mymilitarybenefits.com/finance/military-life-insurance-life-expectancy-calculator/',
    filters: ['Veteran'],
  },
  {
    name: 'VALife Insurance Overview',
    url: 'https://mymilitarybenefits.com/finance/va-life-insurance-overview/',
    filters: ['Veteran'],
  },
  {
    name: 'Types of Life Insurance',
    url: 'https://mymilitarybenefits.com/finance/5-types-of-life-insurance/',
    filters: ['Veteran'],
  },
  {
    name: 'VGLI Overview',
    url: 'https://mymilitarybenefits.com/finance/vgli-veterans-group-life-insurance-overview/',
    filters: ['Veteran'],
  },
  {
    name: 'Little Known Benefits of VGLI',
    url: 'https://mymilitarybenefits.com/finance/little-known-benefits-of-vgli/',
    filters: ['Veteran'],
  },
  {
    name: 'Is SGLI Enough for Military Families?',
    url: 'https://mymilitarybenefits.com/finance/is-sgli-enough-for-military-families/',
    filters: ['Veteran'],
  },
  {
    name: 'Life Insurance for Military Spouses',
    url: 'https://mymilitarybenefits.com/finance/life-insurance-for-military-spouses/',
    filters: ['Veteran'],
  },
  // {
  //   name: 'SGLI Disability Extension',
  //   url: 'https://mymilitarybenefits.com/finance/sgli-disability-extension/',
  //   filters: ['Other'],
  // },
  {
    name: 'FSGLI Life Insurance for Family Members',
    url: 'https://mymilitarybenefits.com/finance/life-insurance-for-military-spouses/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Life Insurance',
    url: 'https://mymilitarybenefits.com/finance/life-insurance-military-veterans/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Survivor Benefit Plan (SBP)',
    url: 'https://mymilitarybenefits.com/benefits/military-survivor-benefit-programs-sbp/ ',
    filters: ['Spouse', 'Dependent'],
  },

  // {
  //   name: 'Military Life Insurance and End of Life Planning',
  //   url: 'https://mymilitarybenefits.com/military-life/military-life-insurance-and-end-of-life-planning/',
  // },
  // {
  //   name: 'Tips for Buying Life Insurance',
  //   url: 'https://mymilitarybenefits.com/finance/tips-for-buying-life-insurance/',
  // },
  // {
  //   name: 'Can I Get Life Insurance with PTSD?',
  //   url: 'https://mymilitarybenefits.com/finance/can-i-get-life-insurance-with-ptsd/',
  // },
  // {
  //   name: 'Calculating Life Expectancy',
  //   url: 'https://mymilitarybenefits.com/benefits/military-life-insurance-life-expectancy-calculator/',
  // },
  // {
  //   name: 'VALife Insurance Overview',
  //   url: 'https://mymilitarybenefits.com/finance/va-life-insurance-overview/',
  // },
  // {
  //   name: 'Types of Life Insurance',
  //   url: 'https://mymilitarybenefits.com/finance/5-types-of-life-insurance/',
  // },
  // {
  //   name: 'VGLI Overview',
  //   url: 'https://mymilitarybenefits.com/finance/vgli-veterans-group-life-insurance-overview/',
  // },
  // {
  //   name: 'Little Known Benefits of VGL',
  //   url: 'https://mymilitarybenefits.com/finance/little-known-benefits-of-vgli/',
  // },
  // {
  //   name: 'For Active Duty, Spouses, Dependents -Is SGLI Enough for Military Families?',
  //   url: 'https://mymilitarybenefits.com/finance/is-sgli-enough-for-military-families/',
  // },
  // {
  //   name: 'For Spouses -Life Insurance for Military Spouses',
  //   url: 'https://mymilitarybenefits.com/finance/life-insurance-for-military-spouses/',
  // },
];

export const EDUCATION_NEWSLETTER = [
  {
    image: '/assets/img/careerrecon-logo.svg',
    url: 'https://careerrecon.com/careerrecon-newsletter/',
    alt: 'career recon logo',
    buttonName: 'subscribe',
    type: 'image',
  },
  {
    image: '/assets/img/logo.1643a230.svg',
    url: 'https://collegerecon.com/collegerecon-newsletter/',
    alt: 'college recon logo',
    buttonName: 'subscribe',
    type: 'image',
  },
  {
    image: '/assets/img/MyMilitaryBenefits.png',
    alt: 'military benefit logo',
    type: 'image',
  },
  {
    image: '',
    url: 'https://mymilitarybenefits.com/mmb-newsletter/',
    alt: 'military benefit logo',
    buttonName: 'subscribe',
    type: 'link',
    text: 'News and Benefits',
  },
  {
    image: '/assets/img/MyMilitaryBenefits.png',
    url: 'https://mymilitarybenefits.com/discounts-newsletter/',
    alt: 'military benefit logo',
    buttonName: 'subscribe',
    type: 'link',
    text: 'Deals and Discounts',
  },
];

export const EMPLOYMENT_NEWSLETTER = [
  {
    image: '/assets/img/careerrecon-logo.svg',
    url: 'https://careerrecon.com/careerrecon-newsletter/',
    alt: 'career recon logo',
    buttonName: 'subscribe',
    type: 'image',
  },
  {
    image: '/assets/img/logo.1643a230.svg',
    url: 'https://collegerecon.com/collegerecon-newsletter/',
    alt: 'college recon logo',
    buttonName: 'subscribe',
    type: 'image',
  },
  {
    image: '/assets/img/MyMilitaryBenefits.png',
    alt: 'military benefit logo',
    type: 'image',
  },
  {
    image: '',
    url: 'https://mymilitarybenefits.com/mmb-newsletter/',
    alt: 'military benefit logo',
    buttonName: 'subscribe',
    type: 'link',
    text: 'News and Benefits',
  },
  {
    image: '/assets/img/MyMilitaryBenefits.png',
    url: 'https://mymilitarybenefits.com/discounts-newsletter/',
    alt: 'military benefit logo',
    buttonName: 'subscribe',
    type: 'link',
    text: 'Deals and Discounts',
  },
];

export const DISCOUNT_SEASONAL = [
  {
    name: 'Golfing',
    url: 'https://mymilitarybenefits.com/discounts/golf-military-discounts/',
  },
  /*{
    name: 'Memorial Day',
    url:
      'https://mymilitarybenefits.com/discounts/memorial-day-discounts/',
  },
  {
    name: 'Military Spouse Appreciation Day',
    url: 'https://mymilitarybenefits.com/discounts/military-spouse-appreciation-day-discounts/',
  },
  {
    name: 'Summer Travel',
    url:
      'https://mymilitarybenefits.com/discounts/best-military-discounts-summer/',
  },
  {
    name: 'Camping / RV Travel',
    url:
      'https://mymilitarybenefits.com/discounts/military-discounts-camping-rv-trip/',

  },
  {
    name: 'Back-to-School Discounts for Military Families',
    url:
      'https://collegerecon.com/back-to-school-discounts-for-military-families/',

  },
  {
    name: 'Back-to-School Discounts for Military & Veteran Students',
    url:
      'https://collegerecon.com/back-to-school-discounts-military-veteran-students/',

  },
  {
    name: 'Back-to-School Shopping Tips',
    url:
      'https://collegerecon.com/back-to-school-shopping-tips/',

  },
  {
    name: 'Save on Back-to-School Shopping with Tax-Free Weekends',
    url:
      'https://collegerecon.com/school-tax-free-weekends/',

  },*/
  {
    name: 'Freebies',
    url: 'https://www.mymilitarybenefits.com/discounts/freebies-military-veterans/',
  },
  {
    name: 'Fishing and Hunting',
    url: 'https://www.mymilitarybenefits.com/discounts/military-discounts-hunt-fish/',
  },
  {
    name: 'Best Student Discounts for Military & Veterans',
    url: 'https://collegerecon.com/student-discounts-veterans-military/',
  },
  {
    name: 'Fitness Gyms',
    url: 'https://www.mymilitarybenefits.com/discounts/fitness-gyms-health-clubs-military-discounts/',
  },
];

export const DISCOUNT_CATEGORIES = [
  {
    name: 'Travel',
    url: 'https://mymilitarybenefits.com/discounts/travel-military-discounts/',
  },
  {
    name: 'Air Travel and Flights',
    url: 'https://mymilitarybenefits.com/discounts/military-discount-flights/',
  },
  {
    name: 'Hotels',
    url: 'https://mymilitarybenefits.com/discounts/hotels-military-discounts/',
  },
  {
    name: 'Cruises',
    url: 'https://mymilitarybenefits.com/discounts/cruise-military-discount/',
  },
  {
    name: 'Rental Cars',
    url: 'https://www.mymilitarybenefits.com/discounts/car-rental-military-discounts/',
  },
  {
    name: 'Cars, Trucks, and Auto Parts',
    url: 'https://www.mymilitarybenefits.com/discounts/best-auto-discounts-military-veterans/',
  },
  {
    name: 'Cell Phones and Cell Phone Plans',
    url: 'https://www.mymilitarybenefits.com/discounts/military-discounts-cell-phones/',
  },
  {
    name: 'Computers, Laptops, and Electronics',
    url: 'https://www.mymilitarybenefits.com/discounts/computer-laptop-military-discounts/',
  },
  {
    name: 'Fishing and Hunting',
    url: 'https://www.mymilitarybenefits.com/discounts/military-discounts-hunt-fish/',
  },
  {
    name: 'Free Camping Sites',
    url: 'https://www.mymilitarybenefits.com/discounts/camp-free-tents-troops/',
  },
  {
    name: 'Freebies',
    url: 'https://www.mymilitarybenefits.com/discounts/freebies-military-veterans/',
  },
  {
    name: 'Restaurants',
    url: 'https://mymilitarybenefits.com/discounts/restaurants-military-discounts/',
  },
];

export const DISCOUNT_POPULAR = [
  {
    name: 'Apple',
    url: 'https://collegerecon.com/apple-military-discount/',
  },
  {
    name: 'Disneyland',
    url: 'https://www.mymilitarybenefits.com/discounts/disneyland-military-discount/',
  },
  {
    name: 'Disney World',
    url: 'https://www.mymilitarybenefits.com/discounts/disney-world-military-discount/',
  },
  {
    name: 'Lowe’s',
    url: 'https://www.mymilitarybenefits.com/discounts/lowes-military-discount/',
  },
  {
    name: 'Home Depot',
    url: 'https://mymilitarybenefits.com/discounts/home-depot-military-discount/',
  },
  {
    name: 'Southwest',
    url: 'https://collegerecon.com/southwest-military-discount/',
  },
  {
    name: 'Costco',
    url: 'https://mymilitarybenefits.com/discounts/costco-military-discount/',
  },
  {
    name: 'Waves of Honor',
    url: 'https://www.mymilitarybenefits.com/discounts/waves-of-honor-military-veterans/',
  },
  {
    name: 'Pilot Truck Stops',
    url: 'https://www.mymilitarybenefits.com/discounts/pilot-truck-stop-military-discount/',
  },
  {
    name: 'TSA PreCheck',
    url: 'https://mymilitarybenefits.com/discounts/tsa-precheck-military/',
  },
  {
    name: 'Space-A',
    url: 'https://mymilitarybenefits.com/benefits/space-a-travel/',
  },
  {
    name: 'Sam’s Club',
    url: 'https://mymilitarybenefits.com/discounts/sams-club-military-discount/',
  },
];

export const STATE_BENEFITS = [
  {
    state: 'Alabama',
    url: 'https://collegerecon.com/alabama-veterans-benefits/',
    value: 'AL',
  },
  {
    state: 'Alaska',
    url: 'https://collegerecon.com/alaska-veterans-benefits/',
    value: 'AK',
  },
  {
    state: 'Arizona',
    url: 'https://collegerecon.com/arizona-veterans-benefits/',
    value: 'AZ',
  },
  {
    state: 'Arkansas',
    url: 'https://collegerecon.com/arkansas-veterans-benefits/',
    value: 'AR',
  },
  {
    state: 'California',
    url: 'https://collegerecon.com/california-veterans-benefits/',
    value: 'CA',
  },
  {
    state: 'Colorado',
    url: 'https://collegerecon.com/colorado-veterans-benefits/',
    value: 'CO',
  },
  {
    state: 'Connecticut',
    url: 'https://collegerecon.com/connecticut-veterans-benefits/',
    value: 'CT',
  },
  {
    state: 'Delaware',
    url: 'https://collegerecon.com/delaware-veterans-benefits/',
    value: 'DE',
  },
  {
    state: 'Florida',
    url: 'https://collegerecon.com/florida-veterans-benefits/',
    value: 'FL',
  },
  {
    state: 'Georgia',
    url: 'https://collegerecon.com/georgia-veterans-benefits/',
    value: 'GA',
  },
  {
    state: 'Guam',
    url: 'https://collegerecon.com/veterans-benefits-territories/',
    value: 'GU',
  },
  {
    state: 'Hawaii',
    url: 'https://collegerecon.com/hawaii-veterans-benefits/',
    value: 'HI',
  },
  {
    state: 'Idaho',
    url: 'https://collegerecon.com/idaho-veterans-benefits/',
    value: 'ID',
  },
  {
    state: 'Illinois',
    url: 'https://collegerecon.com/illinois-veterans-benefits/',
    value: 'IL',
  },
  {
    state: 'Indiana',
    url: 'https://collegerecon.com/indiana-veterans-benefits/',
    value: 'IN',
  },
  {
    state: 'Iowa',
    url: 'https://collegerecon.com/iowa-veterans-benefits/',
    value: 'IA',
  },
  {
    state: 'Kansas',
    url: 'https://collegerecon.com/kansas-veteran-benefits/',
    value: 'KS',
  },
  {
    state: 'Kentucky',
    url: 'https://collegerecon.com/kentucky-veterans-benefits/',
    value: 'KY',
  },
  {
    state: 'Louisiana',
    url: 'https://collegerecon.com/louisiana-veterans-benefits/',
    value: 'LA',
  },
  {
    state: 'Maine',
    url: 'https://collegerecon.com/maine-veterans-benefits/',
    value: 'ME',
  },
  {
    state: 'Maryland',
    url: 'https://collegerecon.com/maryland-veterans-benefits/',
    value: 'MD',
  },
  {
    state: 'Massachusetts',
    url: 'https://collegerecon.com/massachusetts-veterans-benefits/',
    value: 'MA',
  },
  {
    state: 'Michigan',
    url: 'https://collegerecon.com/michigan-veterans-benefits/',
    value: 'MI',
  },
  {
    state: 'Minnesota',
    url: 'https://collegerecon.com/minnesota-veterans-benefits/',
    value: 'MN',
  },
  {
    state: 'Mississippi',
    url: 'https://collegerecon.com/mississippi-veterans-benefits/',
    value: 'MS',
  },
  {
    state: 'Missouri',
    url: 'https://collegerecon.com/missouri-veterans-benefits/',
    value: 'MO',
  },
  {
    state: 'Montana',
    url: 'https://collegerecon.com/montana-veterans-benefits/',
    value: 'MT',
  },
  {
    state: 'Nebraska',
    url: 'https://collegerecon.com/nebraska-veterans-benefits/',
    value: 'NE',
  },
  {
    state: 'Nevada',
    url: 'https://collegerecon.com/nevada-veterans-benefits/',
    value: 'NV',
  },
  {
    state: 'New Hampshire',
    url: 'https://collegerecon.com/new-hampshire-veterans-benefits/',
    value: 'NH',
  },
  {
    state: 'New Jersey',
    url: 'https://collegerecon.com/new-jersey-veterans-benefits/',
    value: 'NJ',
  },
  {
    state: 'New Mexico',
    url: 'https://collegerecon.com/new-mexico-veterans-benefits/',
    value: 'NM',
  },
  {
    state: 'New York',
    url: 'https://collegerecon.com/new-york-veterans-benefits/',
    value: 'NY',
  },
  {
    state: 'North Carolina',
    url: 'https://collegerecon.com/north-dakota-veterans-benefits/',
    value: 'NC',
  },
  {
    state: 'North Dakota',
    url: 'https://collegerecon.com/north-dakota-veterans-benefits/',
    value: 'ND',
  },
  {
    state: 'Northern Marianas Islands',
    url: 'https://collegerecon.com/veterans-benefits-territories/',
    value: 'MP',
  },
  {
    state: 'Ohio',
    url: 'https://collegerecon.com/ohio-veterans-benefits/',
    value: 'OH',
  },
  {
    state: 'Oklahoma',
    url: 'https://collegerecon.com/oklahoma-veterans-benefits/',
    value: 'OK',
  },
  {
    state: 'Oregon',
    url: 'https://collegerecon.com/oregon-veterans-benefits/',
    value: 'OR',
  },
  {
    state: 'Pennsylvania',
    url: 'https://collegerecon.com/pennsylvania-veterans-benefits/',
    value: 'PA',
  },
  {
    state: 'Puerto Rico',
    url: 'https://collegerecon.com/veterans-benefits-territories/',
    value: 'PR',
  },
  {
    state: 'Rhode Island',
    url: 'https://collegerecon.com/rhode-island-veterans-benefits/',
    value: 'RI',
  },
  {
    state: 'South Carolina',
    url: 'https://collegerecon.com/south-carolina-veterans-benefits/',
    value: 'SC',
  },
  {
    state: 'South Dakota',
    url: 'https://collegerecon.com/south-dakota-veterans-benefits/',
    value: 'SD',
  },
  {
    state: 'Tennessee',
    url: 'https://collegerecon.com/tennessee-veterans-benefits/',
    value: 'TN',
  },
  {
    state: 'Texas',
    url: 'https://collegerecon.com/texas-veterans-benefits/',
    value: 'TX',
  },
  {
    state: 'US Virgin Islands',
    url: 'https://collegerecon.com/veterans-benefits-territories/',
    value: 'VI',
  },
  {
    state: 'Utah',
    url: 'https://collegerecon.com/utah-veterans-benefits/',
    value: 'UT',
  },
  {
    state: 'Vermont',
    url: 'https://collegerecon.com/vermont-veterans-benefits/',
    value: 'VT',
  },
  {
    state: 'Virginia',
    url: 'https://collegerecon.com/virginia-veterans-benefits/',
    value: 'VA',
  },
  {
    state: 'Washington',
    value: 'WA',
    url: 'https://collegerecon.com/washington-veterans-benefits/',
  },
  {
    state: 'Washington, DC',
    value: 'WA',
    url: 'https://collegerecon.com/washington-dc-veterans-benefits/',
  },
  {
    state: 'West Virginia',
    value: 'WV',
    url: 'https://collegerecon.com/west-virginia-veterans-benefits/',
  },
  {
    state: 'Wisconsin',
    value: 'WI',
    url: 'https://collegerecon.com/wisconsin-veterans-benefits/',
  },
  {
    state: 'Wyoming',
    value: 'WY',
    url: 'https://collegerecon.com/wyoming-veterans-benefits/',
  },
];

export const DASHBOARD_BENEFIT_GUIDES = [
  {
    name: 'Active Duty Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/active-duty-military-benefits-guide/',
    filters: ['Active', 'Spouse', 'Dependent'],
  },
  {
    name: 'Retiree Pay Dates',
    url: 'https://collegerecon.com/military-pay-dates/',
    filters: ['Retiree'],
  },
  {
    name: 'Annuitant Pay Dates',
    url: 'https://collegerecon.com/military-pay-dates/',
    filters: ['Retiree'],
  },
  {
    name: 'Retirement Pay for Guard & Reserve',
    url: 'https://mymilitarybenefits.com/benefits/retirement-pay-for-guard-and-reserve-members/',
    filters: ['Retiree'],
  },
  {
    name: 'Comprehensive Military Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/comprehensive-military-benefits-guide/',
    filters: [
      'Active',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Spouse',
      'Dependent',
    ],
  },
  {
    name: 'Base Guides',
    url: 'https://mymilitarybenefits.com/military-base/bases-by-state/',
    filters: ['Active'],
  },
  {
    name: 'Military Pay',
    url: 'https://mymilitarybenefits.com/finance/military-pay-charts-2026/',
    filters: ['Active'],
  },
  {
    name: 'Military Pay Dates',
    url: 'https://collegerecon.com/military-pay-dates/',
    filters: ['Active'],
  },
  {
    name: 'Banks with Early Deposit',
    url: 'https://mymilitarybenefits.com/finance/banks-early-deposits-military/',
    filters: ['Active'],
  },
  {
    name: 'Post-9/11 GI Bill',
    url: 'https://collegerecon.com/post-911-gi-bill/',
    filters: ['Active', 'Veteran', 'Retiree'],
  },

  {
    name: 'National Guard and Reserve Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/national-guard-reserve-military-benefits-guide/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Reserve Pay Dates',
    url: 'https://mymilitarybenefits.com/finance/reserve-pay-dates/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'GI Bill for Reserve and National Guard Members',
    url: 'https://collegerecon.com/gi-bill-for-reserve-and-national-guard-members/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'VA Home Loans for Guard & Reserve',
    url: 'https://mymilitarybenefits.com/benefits/national-guard-va-home-loans/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'TRICARE for Guard & Reserve',
    url: 'https://mymilitarybenefits.com/benefits/tricare-for-guard-and-reserve-members/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'TRICARE Reserve Select',
    url: 'https://mymilitarybenefits.com/benefits/tricare-national-guard-reserve/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Retirement Pay for Guard & Reserve',
    url: 'https://mymilitarybenefits.com/benefits/retirement-pay-for-guard-and-reserve-members/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Guard and Reserve Career Transition Resources',
    url: 'https://careerrecon.com/guard-reserve-career-transition-resources/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'TRICARE Guide',
    url: 'https://mymilitarybenefits.com/benefits/tricare-guide/',
    filters: ['Guard', 'Reserve'],
  },
  {
    name: 'Veteran & Retiree Benefits Guides',
    url: 'https://mymilitarybenefits.com/benefits/military-retiree-veteran-benefits-guide/',
    filters: ['Guard', 'Reserve', 'Veteran', 'Retiree'],
  },
  {
    name: 'Applying for VA Disability Benefits',
    url: 'https://mymilitarybenefits.com/benefits/applying-va-disability-benefits/',
    filters: ['Guard', 'Reserve', 'Veteran', 'Retiree'],
  },
  {
    name: 'What Forms Do I Need to Apply for VA Disability?',
    url: 'https://mymilitarybenefits.com/benefits/forms-to-apply-va-disability/',
    filters: ['Guard', 'Reserve', 'Veteran', 'Retiree'],
  },
  {
    name: 'VA Disability Pay Rates',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay/',
    filters: ['Guard', 'Reserve', 'Veteran', 'Retiree'],
  },

  {
    name: 'Montgomery GI Bill',
    url: 'https://collegerecon.com/montgomery-gi-bill/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'Veteran Education Benefits',
    url: 'https://mymilitarybenefits.com/education/veteran-education-benefits-guide/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'Veteran Readiness Employment Program',
    url: 'https://mymilitarybenefits.com/benefits/veteran-readiness-employment-program/',
    filters: ['Veteran', 'Retiree'],
  },

  // {
  //   name: "Veteran's Benefits Guide",
  //   url: 'https://mymilitarybenefits.com/benefits/military-retiree-veteran-benefits-guide/',
  //   type: 'veterans_benefit',
  //   filters: ['Veteran'],
  // },
  // {
  //   name: "Retiree's Benefits Guide",
  //   url: 'https://mymilitarybenefits.com/benefits/military-retiree-veteran-benefits-guide/',
  //   type: 'retirees_benefit',
  //   filters: ['Retiree'],
  // },
  // {
  //   name: 'Reserve & Guard Benefits Guide',
  //   url: 'https://mymilitarybenefits.com/benefits/national-guard-reserve-military-benefits-guide/',
  //   type: '',
  //   filters: ['Guard', 'Reserve'],
  // },
  // {
  //   name: "Spouse & Dependents' Benefits Guide",
  //   url: 'https://mymilitarybenefits.com/benefits/military-spouses-dependents-benefits-guide/',
  //   type: 'reserve',
  //   filters: ['Spouse', 'Dependent'],
  // },

  {
    name: 'Spouse & Dependents Military Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/military-spouses-dependents-benefits-guide/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Lesser Known VA Benefits for Spouses and Dependents',
    url: 'https://mymilitarybenefits.com/benefits/under-utilized-va-benefits-for-spouses-and-dependents/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Military OneSource',
    url: 'https://mymilitarybenefits.com/benefits/military-onesource/',
    filters: ['Spouse', 'Dependent'],
  },
];
export const DASHBOARD_MILITARY_DISCOUNTS = [
  {
    name: 'Airlines / Flights',
    url: 'https://mymilitarybenefits.com/discounts/military-discount-flights/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Hotels',
    url: 'https://mymilitarybenefits.com/discounts/hotels-military-discounts/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'TSA PreCheck',
    url: 'https://mymilitarybenefits.com/discounts/tsa-precheck-military/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Golfing',
    url: 'https://mymilitarybenefits.com/discounts/golf-military-discounts/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Memorial Day',
    url: 'https://mymilitarybenefits.com/discounts/memorial-day-discounts/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Military Spouse Appreciation Day',
    url: 'https://mymilitarybenefits.com/discounts/military-spouse-appreciation-day-discounts/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Summer Travel',
    url: 'https://mymilitarybenefits.com/discounts/best-military-discounts-summer/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Camping / RV Travel',
    url: 'https://mymilitarybenefits.com/discounts/military-discounts-camping-rv-trip/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Grilling & BBQ',
    url: 'https://mymilitarybenefits.com/discounts/grilling-bbq-military-discounts/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Pilot Truck Stops',
    url: 'https://mymilitarybenefits.com/discounts/pilot-truck-stop-military-discount/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  {
    name: 'Costco',
    url: 'https://mymilitarybenefits.com/discounts/costco-military-discount/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  // {
  //   name: 'PCS Moving Resources',
  //   url: 'https://mymilitarybenefits.com/benefits/pcs-moving-resources-support/ ',
  //   filters: ['Active', 'Spouse'],
  // },
  // {
  //   name: 'PCS Spring Cleaning',
  //   url: 'https://mymilitarybenefits.com/finance/spring-cleaning-and-pcs-prep-companies-that-can-help/',
  //   filters: ['Active', 'Spouse'],
  // },
  {
    name: 'National Military Appreciation Month',
    url: 'https://mymilitarybenefits.com/discounts/national-military-appreciation-month-discounts/',
    filters: [
      'Active',
      'Spouse',
      'Guard',
      'Reserve',
      'Veteran',
      'Retiree',
      'Dependent',
    ],
  },
  // {
  //   name: 'Freebies',
  //   url: 'https://www.mymilitarybenefits.com/discounts/freebies-military-veterans/',
  //   filters: [
  //     'Active',
  //     'Spouse',
  //     'Guard',
  //     'Reserve',
  //     'Veteran',
  //     'Retiree',
  //     'Dependent',
  //   ],
  // },
  // {
  //   name: 'Fishing and Hunting',
  //   url: 'https://www.mymilitarybenefits.com/discounts/military-discounts-hunt-fish/',
  //   filters: [
  //     'Active',
  //     'Spouse',
  //     'Guard',
  //     'Reserve',
  //     'Veteran',
  //     'Retiree',
  //     'Dependent',
  //   ],
  // },
  // {
  //   name: 'Military Discounts on Camping',
  //   url: 'https://mymilitarybenefits.com/discounts/military-discounts-camping-rv-trip/',
  //   filters: [
  //     'Active',
  //     'Spouse',
  //     'Guard',
  //     'Reserve',
  //     'Veteran',
  //     'Retiree',
  //     'Dependent',
  //   ],
  // },
  // {
  //   name: 'PCS Moving Resources',
  //   url: 'https://mymilitarybenefits.com/benefits/pcs-moving-resources-support/',
  //   filters: ['Active', 'Spouse'],
  // },
  // {
  //   name: 'PCS Spring Cleaning',
  //   url: 'https://mymilitarybenefits.com/finance/spring-cleaning-and-pcs-prep-companies-that-can-help/',
  //   filters: ['Active', 'Spouse'],
  // },
];

export const EDUCATION_DISABILITY_GUIDES = [
  {
    name: 'Education Benefits for Disabled Veterans',
    url: 'https://mymilitarybenefits.com/education/education-benefits-for-disabled-veterans/',
  },
];

export const BENEFIT_DISABILITY_GUIDES = [
  {
    name: 'Disabled Veteran Benefits Guide',
    url: 'https://mymilitarybenefits.com/benefits/disabled-veteran-benefits-guide/',
    filters: ['Veteran', 'Retiree'],
  },
  // {
  //   name: 'State Benefits for Disabled Veterans',
  //   url: 'https://mymilitarybenefits.com/benefits/where-to-find-state-benefits-for-disabled-veterans/',
  // },
  {
    name: 'Education Benefits for Disabled Veterans',
    url: 'https://mymilitarybenefits.com/education/education-benefits-for-disabled-veterans/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'Forms to Apply for VA Disability',
    url: 'https://mymilitarybenefits.com/benefits/forms-to-apply-va-disability/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'How to Apply for VA Disability Benefits',
    url: 'https://mymilitarybenefits.com/benefits/applying-va-disability-benefits/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'How to File VA Disability Claims',
    url: 'https://mymilitarybenefits.com/benefits/how-to-file-for-a-va-disability-increase/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'VA Disability Benefits Eligibility',
    url: 'https://mymilitarybenefits.com/benefits/eligibility-va-disability-benefits/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'Mistakes to Avoid on VA Claims',
    url: 'https://mymilitarybenefits.com/benefits/how-to-avoid-mistakes-when-claiming-va-disability-benefits/',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'VA Disability Pay Rates',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay/',
    filters: ['Veteran', 'Retiree'],
  },
];

export const BENEFIT_DISABILITY_PAY = [
  {
    name: 'VA Disability Pay',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay/',
  },
  {
    name: 'VA Compensation for Service Connected Disabilities',
    url: 'https://mymilitarybenefits.com/benefits/va-compensation-for-service-connected-disabilities/',
  },
];

export const BENEFIT_DISABILITY_VALOAN = [
  {
    name: 'VA Loan Funding Fee Exemptions for Disabled Veterans',
    url: 'https://mymilitarybenefits.com/finance/va-loan-funding-fee-exemptions-for-disabled-veterans/',
  },
];

export const BENEFIT_VA_DISABILITY_FOR_YOU = [
  {
    name: 'VA Disability Benefits Eligibility',
    url: 'https://mymilitarybenefits.com/benefits/eligibility-va-disability-benefits/',
  },
  {
    name: 'VA Disability Pay Rates',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay/',
  },
  {
    name: 'Federal Resources for New Disabled Veterans',
    url: 'https://mymilitarybenefits.com/benefits/important-federal-resources-for-new-disabled-veterans/',
  },
  {
    name: 'Education Benefits Disabled Vets',
    url: 'https://mymilitarybenefits.com/education/education-benefits-for-disabled-veterans/',
  },
  {
    name: 'VA Disabilities Appearing After Discharge',
    url: 'https://mymilitarybenefits.com/benefits/va-benefits-disabilities-appearing-year-after-discharge/',
  },
  {
    name: 'AUTO Act',
    url: 'https://mymilitarybenefits.com/benefits/enhanced-benefits-disabled-veterans-auto-act/',
  },
];

export const BENEFIT_VADISABILITY_CLAIM = [
  // {
  //   name: 'Form To Apply',
  //   url: 'https://mymilitarybenefits.com/benefits/forms-to-apply-va-disability/',
  // },
  // {
  //   name: 'Eligibility Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/eligibility-va-disability-benefits/',
  // },
  // {
  //   name: 'Disability Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/applying-va-disability-benefits/',
  // },
  // {
  //   name: 'Need Help Filing Claim',
  //   url: 'https://mymilitarybenefits.com/benefits/do-you-need-help-filing-a-va-disability-claim/',
  // },
  // {
  //   name: 'Avoid Mistakes In Claim Benefits',
  //   url: 'https://mymilitarybenefits.com/benefits/how-to-avoid-mistakes-when-claiming-va-disability-benefits/',
  // },
  // {
  //   name: 'File For Disability Increase',
  //   url: 'https://mymilitarybenefits.com/benefits/how-to-file-for-a-va-disability-increase/',
  // },
  {
    name: 'How to Avoid Making Mistakes When Claiming VA Disability Benefits',
    url: 'https://mymilitarybenefits.com/benefits/how-to-avoid-mistakes-when-claiming-va-disability-benefits/',
  },
  {
    name: 'Forms to Apply for VA Disability',
    url: 'https://mymilitarybenefits.com/benefits/forms-to-apply-va-disability/',
  },
  {
    name: 'How to Apply for VA Disability Benefits',
    url: 'https://mymilitarybenefits.com/benefits/applying-va-disability-benefits/',
  },
  {
    name: 'How to Apply for VA Disability Increase',
    url: 'https://mymilitarybenefits.com/benefits/how-to-file-for-a-va-disability-increase/',
  },
  {
    name: 'How to File VA Disability Claims',
    url: 'https://mymilitarybenefits.com/benefits/file-va-disability-claims/',
  },
];

export const EMPLOYMENT_DISABILITY_GUIDE = [
  {
    name: 'Disabled Veteran Preference in Hiring',
    url: 'https://mymilitarybenefits.com/employment/what-to-know-about-disabled-veteran-preference-in-state-and-federal-hiring/',
  },
];

export const EMPLOYMENT_MILITARY_GUIDE = [
  {
    name: 'Military Spouse Employment Guide',
    url: 'https://careerrecon.com/military-spouse-employment-guide/',

    filters: ['Spouse'],
  },
  {
    name: 'Types of Work for Spouses',
    url: 'https://careerrecon.com/military-spouse-type-of-work/',

    filters: ['Spouse'],
  },
  {
    name: 'Certification & Training Resources',
    url: 'https://careerrecon.com/military-spouse-employment-guide-resources-for-certifications-and-training-programs/',

    filters: ['Spouse'],
  },
  {
    name: 'Prepare Your Mind',
    url: 'https://careerrecon.com/military-spouse-employment-prepare-your-mind/',

    filters: ['Spouse'],
  },
  {
    name: 'Strategic Job Searching',
    url: 'https://careerrecon.com/military-spouse-employment-guide-strategic-job-searching/',

    filters: ['Spouse'],
  },
  {
    name: 'The Portability Factor',
    url: 'https://careerrecon.com/military-spouse-employment-the-portability-factor/',

    filters: ['Spouse'],
  },
  {
    name: 'How to Find Internships & Volunteer Work',
    url: 'https://careerrecon.com/how-to-find-internships-volunteer-work/',

    filters: ['Spouse'],
  },
  {
    name: 'How Military Spouse Preference Works',
    url: 'https://careerrecon.com/how-military-spouse-preference-works/',

    filters: ['Spouse'],
  },
  {
    name: 'How Spouses Can Change Their Career',
    url: 'https://careerrecon.com/your-employment-questions-answered-how-to-change-your-career-as-a-veteran-spouse/',

    filters: ['Spouse'],
  },
  {
    name: 'Military Transition Roadmap',
    url: 'https://careerrecon.com/military-transition-roadmap-step-1/',

    filters: ['Active'],
  },
  {
    name: 'Researching Jobs for Military',
    url: 'https://careerrecon.com/military-researching-jobs/',

    filters: ['Active'],
  },
  {
    name: 'Research on Retirees',
    url: 'https://careerrecon.com/retirees-critical-targeting-and-research-of-organizations-and-companies/',

    filters: ['Retiree'],
  },
  {
    name: 'Retiree Executive Resume',
    url: 'https://careerrecon.com/retirees-write-a-highly-targeted-executive-resume/',

    filters: ['Retiree'],
  },
  {
    name: 'Organizations that Assist Guard & Reserve with Finding Employment',
    url: 'https://careerrecon.com/guard-reserve-organizations-that-help-the-national-guard-and-reserves-find-employment/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Being Discreet About Your Reservist Status',
    url: 'https://careerrecon.com/guard-reserve-being-discreet-about-your-reservist-status/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Guard & Reserve: Success with Your Employer',
    url: 'https://careerrecon.com/guard-reserve-success-with-your-employer/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Guard & Reserve: Success at Work',
    url: 'https://careerrecon.com/guard-reserve-success-at-work/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Guard & Reserve: Assistance for You and Your Employer',
    url: 'https://careerrecon.com/guard-reserve-assistance-for-you-and-your-employer/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Finding Military Friendly Colleges for Guard & Reserve',
    url: 'https://careerrecon.com/guard-reserve-employment-guide-finding-military-friendly-colleges/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Researching Jobs for Military',
    url: 'https://careerrecon.com/military-researching-jobs/',

    filters: ['Veteran'],
  },
  {
    name: 'General Resume Help for the Military',
    url: 'https://careerrecon.com/resume-general-military-employment-guide/',

    filters: ['Veteran'],
  },
  {
    name: 'How to Get the Most Out of LinkedIn',
    url: 'https://careerrecon.com/military-employment-guide-linkedin/',

    filters: ['Veteran'],
  },
  {
    name: 'Finding Mentors',
    url: 'https://careerrecon.com/military-employment-guide-finding-mentors/',

    filters: ['Veteran'],
  },
  {
    name: 'Networking Guide for Military & Veterans',
    url: 'https://careerrecon.com/networking-military-veterans/',

    filters: ['Veteran'],
  },
];

export const EMPLOYMENT_MILITARY_USEFUL_GUIDE = [
  {
    name: 'Free Six Sigma Courses',
    url: 'https://careerrecon.com/free-six-sigma-courses-military-veterans/',

    filters: ['Spouse'],
  },
  {
    name: 'Military Spouse Career Accelerator Program',
    url: 'https://careerrecon.com/military-spouse-career-accelerator-program/',

    filters: ['Spouse'],
  },
  {
    name: 'How to Prepare for and Find a Remote Job',
    url: 'https://careerrecon.com/how-to-prepare-find-remote-job/',

    filters: ['Spouse'],
  },
  {
    name: 'Research & Translate Your Military Skills',
    url: 'https://careerrecon.com/evaluate-your-skills-translate-your-story-skills/',

    filters: ['Active'],
  },
  {
    name: 'Cover Letter Help for the Military',
    url: 'https://careerrecon.com/step-by-step-guide-to-employment-cover-letter-general-military/',

    filters: ['Active'],
  },
  {
    name: 'General Resume Help for the Military',
    url: 'https://careerrecon.com/resume-general-military-employment-guide/',

    filters: ['Active'],
  },
  {
    name: 'Where to Find Help with Your Resume',
    url: 'https://careerrecon.com/where-to-go-for-resume-help/',

    filters: ['Active'],
  },
  {
    name: 'How to Apply for Jobs',
    url: 'https://careerrecon.com/military-employment-guide-applying-for-jobs/',

    filters: ['Active'],
  },
  {
    name: 'Professional Headshots',
    url: 'https://careerrecon.com/military-employment-guide-professional-headshots//',

    filters: ['Active'],
  },
  {
    name: 'How to Get the Most Out of LinkedIn',
    url: 'https://careerrecon.com/military-employment-guide-linkedin/',

    filters: ['Active'],
  },
  {
    name: 'Finding Mentors',
    url: 'https://careerrecon.com/military-employment-guide-finding-mentors/',

    filters: ['Active'],
  },
  {
    name: 'Networking Guide for Military & Veterans',
    url: 'https://careerrecon.com/networking-military-veterans/',

    filters: ['Active'],
  },
  {
    name: 'Elevator Pitch Guide',
    url: 'https://careerrecon.com/elevator-pitch-guide-general-military/',

    filters: ['Active'],
  },
  {
    name: 'Interview Preparation',
    url: 'https://careerrecon.com/military-employment-guide-interview-preparation/',

    filters: ['Active'],
  },
  {
    name: 'Business Attire',
    url: 'https://careerrecon.com/business-attire-military-employment-guide/',

    filters: ['Active'],
  },
  {
    name: 'Interviewing and Follow-Up',
    url: 'https://careerrecon.com/military-employment-guide-interviewing-and-follow-up/',

    filters: ['Active'],
  },
  {
    name: 'Best Jobs for Veterans without Degrees',
    url: 'https://careerrecon.com/best-jobs-veterans-without-degrees/',

    filters: ['Active'],
  },
  {
    name: 'VA Career & Educational Counseling for Veterans',
    url: 'https://careerrecon.com/va-career-education-counseling-veterans/',

    filters: ['Active'],
  },
  {
    name: 'Free Six Sigma Courses',
    url: 'https://careerrecon.com/free-six-sigma-courses-military-veterans/',

    filters: ['Active'],
  },
  {
    name: 'How to Prepare for and Find a Remote Job',
    url: 'https://careerrecon.com/how-to-prepare-find-remote-job/',

    filters: ['Active'],
  },
  {
    name: 'Research & Translate Your Military Skills',
    url: 'https://careerrecon.com/evaluate-your-skills-translate-your-story-skills/',

    filters: ['Retiree'],
  },
  {
    name: 'Cover Letter Help for the Military',
    url: 'https://careerrecon.com/step-by-step-guide-to-employment-cover-letter-general-military/',

    filters: ['Retiree'],
  },
  {
    name: 'General Resume Help for the Military',
    url: 'https://careerrecon.com/resume-general-military-employment-guide/',

    filters: ['Retiree'],
  },
  {
    name: 'Where to Find Help with Your Resume',
    url: 'https://careerrecon.com/where-to-go-for-resume-help/',

    filters: ['Retiree'],
  },
  {
    name: 'How to Apply for Jobs',
    url: 'https://careerrecon.com/military-employment-guide-applying-for-jobs/',

    filters: ['Retiree'],
  },
  {
    name: 'Professional Headshots',
    url: 'https://careerrecon.com/military-employment-guide-professional-headshots/',

    filters: ['Retiree'],
  },
  {
    name: 'How to Get the Most Out of LinkedIn',
    url: 'https://careerrecon.com/military-employment-guide-linkedin/',

    filters: ['Retiree'],
  },
  {
    name: 'Finding Mentors',
    url: 'https://careerrecon.com/military-employment-guide-finding-mentors/',

    filters: ['Retiree'],
  },
  {
    name: 'Networking Guide for Military & Veterans',
    url: 'https://careerrecon.com/networking-military-veterans/',

    filters: ['Retiree'],
  },
  {
    name: 'Elevator Pitch Guide',
    url: 'https://careerrecon.com/elevator-pitch-guide-general-military/',

    filters: ['Retiree'],
  },
  {
    name: 'Interview Preparation',
    url: 'https://careerrecon.com/military-employment-guide-interview-preparation/',

    filters: ['Retiree'],
  },
  {
    name: 'Business Attire',
    url: 'https://careerrecon.com/business-attire-military-employment-guide/',

    filters: ['Retiree'],
  },
  {
    name: 'Interviewing and Follow-Up',
    url: 'https://careerrecon.com/military-employment-guide-interviewing-and-follow-up/',

    filters: ['Retiree'],
  },
  {
    name: 'Best Jobs for Veterans without Degrees',
    url: 'https://careerrecon.com/best-jobs-veterans-without-degrees/',

    filters: ['Retiree'],
  },
  {
    name: 'VA Career & Educational Counseling for Veterans',
    url: 'https://careerrecon.com/va-career-education-counseling-veterans/',

    filters: ['Retiree'],
  },
  {
    name: 'Free Six Sigma Courses',
    url: 'https://careerrecon.com/free-six-sigma-courses-military-veterans/',

    filters: ['Retiree'],
  },
  {
    name: 'How to Prepare for and Find a Remote Job',
    url: 'https://careerrecon.com/how-to-prepare-find-remote-job/',

    filters: ['Retiree'],
  },
  {
    name: 'Free Six Sigma Courses',
    url: 'https://careerrecon.com/free-six-sigma-courses-military-veterans/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'How to Prepare for and Find a Remote Job',
    url: 'https://careerrecon.com/how-to-prepare-find-remote-job/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Research & Translate Your Military Skills',
    url: 'https://careerrecon.com/evaluate-your-skills-translate-your-story-skills/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Cover Letter Help for the Military',
    url: 'https://careerrecon.com/step-by-step-guide-to-employment-cover-letter-general-military/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'General Resume Help for the Military',
    url: 'https://careerrecon.com/resume-general-military-employment-guide/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Where to Find Help with Your Resume',
    url: 'https://careerrecon.com/where-to-go-for-resume-help/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Professional Headshots',
    url: 'https://careerrecon.com/military-employment-guide-professional-headshots/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'How to Get the Most Out of LinkedIn',
    url: 'https://careerrecon.com/military-employment-guide-linkedin/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Finding Mentors',
    url: 'https://careerrecon.com/military-employment-guide-finding-mentors/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Networking Guide for Military & Veterans',
    url: 'https://careerrecon.com/networking-military-veterans/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Elevator Pitch Guide',
    url: 'https://careerrecon.com/elevator-pitch-guide-general-military/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Interview Preparation',
    url: 'https://careerrecon.com/military-employment-guide-interview-preparation/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Business Attire',
    url: 'https://careerrecon.com/business-attire-military-employment-guide/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Interviewing and Follow-Up',
    url: 'https://careerrecon.com/military-employment-guide-interviewing-and-follow-up/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Best Jobs for Veterans without Degrees',
    url: 'https://careerrecon.com/best-jobs-veterans-without-degrees/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'VA Career & Educational Counseling for Veterans',
    url: 'https://careerrecon.com/va-career-education-counseling-veterans/',

    filters: ['Reserve', 'Guard'],
  },
  {
    name: 'Research & Translate Your Military Skills',
    url: 'https://careerrecon.com/evaluate-your-skills-translate-your-story-skills/',

    filters: ['Veteran'],
  },
  {
    name: 'Cover Letter Help for the Military',
    url: 'https://careerrecon.com/step-by-step-guide-to-employment-cover-letter-general-military/',

    filters: ['Veteran'],
  },
  {
    name: 'General Resume Help for the Military',
    url: 'https://careerrecon.com/resume-general-military-employment-guide/',

    filters: ['Veteran'],
  },
  {
    name: 'Where to Find Help with Your Resume',
    url: 'https://careerrecon.com/where-to-go-for-resume-help/',

    filters: ['Veteran'],
  },
  {
    name: 'How to Apply for Jobs',
    url: 'https://careerrecon.com/military-employment-guide-applying-for-jobs/',

    filters: ['Veteran'],
  },
  {
    name: 'Professional Headshots',
    url: 'https://careerrecon.com/military-employment-guide-professional-headshots/',

    filters: ['Veteran'],
  },
  {
    name: 'How to Get the Most Out of LinkedIn',
    url: 'https://careerrecon.com/military-employment-guide-linkedin/',

    filters: ['Veteran'],
  },
  {
    name: 'Finding Mentors',
    url: 'https://careerrecon.com/military-employment-guide-finding-mentors/',

    filters: ['Veteran'],
  },
  {
    name: 'Networking Guide for Military & Veterans',
    url: 'https://careerrecon.com/networking-military-veterans/',

    filters: ['Veteran'],
  },
  {
    name: 'Elevator Pitch Guide',
    url: 'https://careerrecon.com/elevator-pitch-guide-general-military/',

    filters: ['Veteran'],
  },
  {
    name: 'Elevator Pitch Guide',
    url: 'https://careerrecon.com/elevator-pitch-guide-general-military/',

    filters: ['Veteran'],
  },
  {
    name: 'Interview Preparation',
    url: 'https://careerrecon.com/military-employment-guide-interview-preparation/',

    filters: ['Veteran'],
  },
  {
    name: 'Business Attire',
    url: 'https://careerrecon.com/business-attire-military-employment-guide/',

    filters: ['Veteran'],
  },
  {
    name: 'Interviewing and Follow-Up',
    url: 'https://careerrecon.com/military-employment-guide-interviewing-and-follow-up/',

    filters: ['Veteran'],
  },
  {
    name: 'Best Jobs for Veterans without Degrees',
    url: 'https://careerrecon.com/best-jobs-veterans-without-degrees/',

    filters: ['Veteran'],
  },
  {
    name: 'VA Career & Educational Counseling for Veterans',
    url: 'https://careerrecon.com/va-career-education-counseling-veterans',

    filters: ['Veteran'],
  },
  {
    name: 'Free Six Sigma Courses',
    url: 'https://careerrecon.com/free-six-sigma-courses-military-veterans/',

    filters: ['Veteran'],
  },
  {
    name: 'How to Prepare for and Find a Remote Job',
    url: 'https://careerrecon.com/how-to-prepare-find-remote-job/',

    filters: ['Veteran'],
  },
];

export const EMPLOYMENT_GUIDES_GUIDE = [
  {
    name: 'Employment Assistance',
    url: 'https://mymilitarybenefits.com/benefits/transition-employment-assistance-for-military-spouses-and-caregivers/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Overseas Military Spouse Career Options',
    url: 'https://mymilitarybenefits.com/employment/overseas-military-spouse-career-options/',
    filters: ['Spouse', 'Dependent'],
  },
  {
    name: 'Military Spouse Career Accelerator Program',
    url: 'https://careerrecon.com/military-spouse-career-accelerator-program/',
    filters: ['Spouse'],
  },
  {
    name: 'Military Spouse Employment Guide: Resources for Certifications and Training Programs',
    url: 'https://careerrecon.com/military-spouse-employment-guide-resources-for-certifications-and-training-programs/',
    filters: ['Spouse'],
  },
  {
    name: 'Step-by-Step Guide to Employment for Military Spouses',
    url: 'https://careerrecon.com/military-spouse-employment-guide/',
    filters: ['Spouse'],
  },
  {
    name: 'Military Spouse Career Transitions Overseas',
    url: 'https://careerrecon.com/military-spouse-career-transition-overseas-jobs/',
    filters: ['Spouse'],
  },
  {
    name: 'Military Spouse Career Accelerator Program',
    url: 'https://careerrecon.com/military-spouse-career-accelerator-program/',
    filters: ['Spouse'],
  },
  {
    name: 'Military Spouse Employment Guide: Strategic Job Searching',
    url: 'https://careerrecon.com/military-spouse-employment-guide-strategic-job-searching/',
    filters: ['Spouse'],
  },
];

// task_1040: the Separation tab was removed and its links merged in here —
// separation links appended after the transition links, duplicates (by URL)
// folded into the transition entry with merged filters.
export const EMPLOYMENT_TRANSITION_GUIDE = [
  {
    name: 'Transition Assistance Program (TAP)',
    url: 'https://mymilitarybenefits.com/benefits/va-pre-separation-counseling/',
    // 'Spouse' merged from the former Separation list
    filters: ['Active', 'Spouse'],
  },
  {
    name: 'Pre-Separation Counseling',
    url: 'https://discover.va.gov/transition-programs/transition-assistance-program/',
    filters: ['Active'],
  },
  {
    name: 'Benefits Delivery at Discharge (BDD)',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay-benefits-delivery-discharge-program/',
    filters: ['Active'],
  },
  {
    name: 'Non-VA Resources for Military Transition Assistance',
    url: 'https://mymilitarybenefits.com/benefits/non-va-resources-for-military-transition-assistance/',
    filters: ['Active'],
  },
  {
    name: 'Solid Start Program',
    url: 'https://mymilitarybenefits.com/benefits/solid-start-helping-veterans-transition/',
    // 'Veteran' merged from the former Separation list
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Skillbridge Upcoming Events',
    url: 'https://careerrecon.com/skillbridge-upcoming-events-updated/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Time-Sensitive VA Benefits',
    url: 'https://mymilitarybenefits.com/benefits/time-sensitive-va-benefits/',
    filters: ['Active', 'Veteran'],
  },
  // ── Former Separation links ────────────────────────────────────────────────
  {
    name: 'FAQ: Non-VA Transition Resources',
    url: 'https://careerrecon.com/frequently-asked-questions-non-va-career-transition-resources/',
    filters: ['Veteran'],
  },
  {
    name: 'Employment Assistance',
    url: 'https://mymilitarybenefits.com/benefits/transition-employment-assistance-for-military-spouses-and-caregivers/',
    filters: ['Veteran'],
  },
  {
    name: 'Job Placement Services',
    url: 'https://mymilitarybenefits.com/employment/best-veteran-job-sites/',
    filters: ['Veteran'],
  },
  {
    name: 'How to Prepare for Civilian Job Fairs',
    url: 'https://careerrecon.com/how-to-prepare-virtual-job-fairs/',
    filters: ['Veteran'],
  },
];

export const EMPLOYMENT_ROADMAP_GUIDE = [
  {
    name: 'Military to Civilian Transition 101',
    url: 'https://careerrecon.com/military-to-civilian-transitions-101/',
    filters: ['Active'],
  },
  {
    name: 'Step 1: Military Transition Roadmap',
    url: 'https://careerrecon.com/military-transition-roadmap-step-1/',
    filters: ['Active'],
  },
  {
    name: 'Step 2: Military Transition Roadmap',
    url: 'https://careerrecon.com/transition-roadmap-step-2/',
    filters: ['Active'],
  },
  {
    name: 'Step 3: Military Transition Roadmap',
    url: 'https://careerrecon.com/transition-roadmap-step-3/',
    filters: ['Active'],
  },
  {
    name: 'Step 4: Military Transition Roadmap',
    url: 'https://careerrecon.com/transition-roadmap-step-4/',
    filters: ['Active'],
  },
  {
    name: 'Step 5: Military Transition Roadmap',
    url: 'https://careerrecon.com/transition-roadmap-step-5/',
    filters: ['Active'],
  },
  {
    name: 'Step 6: Military Transition Roadmap',
    url: 'https://careerrecon.com/transition-roadmap-step-6/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Step 7: Military Transition Roadmap',
    url: 'https://careerrecon.com/transition-roadmap-step-7/',
    filters: ['Active', 'Veteran'],
  },
];

export const EMPLOYMENT_RESOURCES_GUIDE = [
  {
    name: 'FAQ: Non-VA Transition Resources',
    url: 'https://careerrecon.com/frequently-asked-questions-non-va-career-transition-resources/',
    filters: ['Active'],
  },
  {
    name: 'How to Dress for a Civilian Interview',
    url: 'https://careerrecon.com/business-attire-military-employment-guide/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Elevator Pitch Guide for Military',
    url: 'https://careerrecon.com/elevator-pitch-guide-general-military/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Evaluate & Translate Your Skills',
    url: 'https://careerrecon.com/evaluate-your-skills-translate-your-story-skills/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'How to Prepare to Find a Remote Job',
    url: 'https://careerrecon.com/how-to-prepare-find-remote-job/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Applying for Jobs',
    url: 'https://careerrecon.com/military-employment-guide-applying-for-jobs/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Finding Mentors',
    url: 'https://careerrecon.com/military-employment-guide-finding-mentors/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Interview Preparation',
    url: 'https://careerrecon.com/military-employment-guide-interview-preparation/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Following Up After an Interview',
    url: 'https://careerrecon.com/military-employment-guide-interviewing-and-follow-up/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Professional Headshots',
    url: 'https://careerrecon.com/military-employment-guide-professional-headshots/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Researching Jobs',
    url: 'https://careerrecon.com/military-researching-jobs/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Networking for Military Veterans',
    url: 'https://careerrecon.com/networking-military-veterans/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Resume Guide',
    url: 'https://careerrecon.com/resume-general-military-employment-guide/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Resume Help: Where to Go',
    url: 'https://careerrecon.com/where-to-go-for-resume-help/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Cover Letter',
    url: 'https://careerrecon.com/step-by-step-guide-to-employment-cover-letter-general-military/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Translate Your Military Skills & Experience',
    url: 'https://careerrecon.com/translate-your-military-skills-and-experience/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Using a Recruiting Agency for your Transition',
    url: 'https://careerrecon.com/using-a-recruiting-agency-to-transition-out-of-the-military/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Veterans Guide to Buying a Franchise',
    url: 'https://careerrecon.com/veterans-guide-buying-franchise/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'List of Companies that Hire Veterans',
    url: 'https://careerrecon.com/list-of-companies-that-hire-veterans-transitioning-service-members/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Underrated Careers for Veterans',
    url: 'https://careerrecon.com/underrated-careers-for-veterans-after-leaving-the-military/',
    filters: ['Active', 'Veteran'],
  },
];

export const EMPLOYMENT_SPOUSE_GUIDE = [
  {
    name: 'Military Spouse Career Accelerator Program',
    url: 'https://careerrecon.com/military-spouse-career-accelerator-program/',
    filters: ['Active', 'Veteran'],
  },
];

export const EMPLOYMENT_TRAINING_GUIDE = [
  {
    name: 'Alison Offers Free Online Courses',
    url: 'https://careerrecon.com/alison-free-online-courses-veterans-military-spouses/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'Continued Education & Training',
    url: 'https://careerrecon.com/continued-education-training-military/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'Free Online Courses & Certifications',
    url: 'https://careerrecon.com/free-online-courses-certifications-veterans-military-spouses/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'Free Six Sigma Courses',
    url: 'https://careerrecon.com/free-six-sigma-courses-military-veterans/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'How to Find Courses to Improve Your Skills',
    url: 'https://careerrecon.com/how-to-find-courses-to-improve-your-skills/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'Short Online Learning Programs',
    url: 'https://careerrecon.com/short-online-learning-programs-military-friendly-schools/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'High-Income Blue Collar Careers',
    url: 'https://careerrecon.com/high-income-blue-collar-careers/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran', 'Spouse', 'Dependent'],
  },
  {
    name: 'Sigma Forces Offers Career Help and Free Courses',
    url: 'https://careerrecon.com/career-help-free-courses-veterans-military-spouses/',
    filters: ['Active', 'Guard', 'Reserve', 'Veteran', 'Spouse', 'Dependent'],
  },
];

export const EMPLOYMENT_PATHWAYS_GUIDE = [
  {
    name: 'Supply Chain Management',
    url: 'https://careerrecon.com/industry-pathway-supply-chain-management/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Radiological Technologist',
    url: 'https://careerrecon.com/radiological-technologist-career-pathway/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Integrative and Functional Medicine - Lifestyle Medicine',
    url: 'https://careerrecon.com/integrative-and-functional-medicine-lifestyle-medicine/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Integrative and Functional Medicine - Nutrition',
    url: 'https://careerrecon.com/integrative-functional-medicine-nutrition-career-pathway/',
    filters: ['Active', 'Veteran'],
  },
  {
    name: 'Ultrasound Diagnostic Medical Sonography',
    url: 'https://careerrecon.com/ultrasound-diagnostic-medical-sonography/',
    filters: ['Active', 'Veteran'],
  },
];

export const EDUCATION_GUIDE_PDF = [
  {
    name: 'Active Duty Education Guide',
    url: 'https://s3.amazonaws.com/collegerecon.prod.assets/assets/ad-assets/guide-active-duty.pdf',
    filters: ['Active', 'Guard', 'Reserve'],
  },
  {
    name: 'Veteran Education Guide',
    url: 'https://s3.amazonaws.com/collegerecon.prod.assets/assets/ad-assets/guide-veteran.pdf',
    filters: ['Veteran', 'Retiree'],
  },
  {
    name: 'Spouse Education Guide',
    url: 'https://s3.amazonaws.com/collegerecon.prod.assets/assets/ad-assets/guide-military-spouse.pdf',
    filters: ['Dependent', 'Spouse'],
  },
];

// Scholarships Filters
export const SCHOLARSHIP_GENDER = [
  { value: 'sex_male', label: 'Male' },
  { value: 'sex_female', label: 'Female' },
  { value: 'sex_non_binary', label: 'Non-binary' },
  { value: 'sex_other', label: 'Other' },
  { value: 'sex_prefer_not', label: 'Prefer not to state' },
];

export const SCHOLARSHIP_MINORITY_BACKGROUND = [
  { value: 'student_ethnic_aab', label: 'African American / Black' },
  { value: 'student_ethnic_ai', label: 'American Indian' },
  { value: 'student_ethnic_ll', label: 'Latino/Latina' },
  { value: 'student_ethnic_mac', label: 'Mexican American / Chicano' },
  { value: 'student_ethnic_aa', label: 'Asian / Asian American' },
  { value: 'student_ethnic_cc', label: 'Caucasian / White' },
];

export const SCHOLARSHIP_STUDENT_DISABILITY = [
  { value: 'student_disability_bvi', label: 'Blind / Visually Impaired' },
  { value: 'student_disability_dhi', label: 'Deaf / Hearing Impaired' },
  { value: 'student_disability_ld', label: 'Learning Disability' },
  { value: 'student_disability_pd', label: 'Physically Disabled' },
];

export const SCHOLARSHIP_MILITARY_BRANCH = [
  { value: 'military_branch_army', label: 'Army' },
  { value: 'military_branch_marine_corps', label: 'Marine Corps' },
  { value: 'military_branch_navy', label: 'Navy' },
  { value: 'military_branch_air_force', label: 'Air Force' },
  { value: 'military_branch_coast_guard', label: 'Coast Guard' },
  { value: 'military_branch_space_force', label: 'Space Force' },
  { value: 'military_branch_other', label: 'Other' },
];

export const SCHOLARSHIP_MILITARY_STATUS = [
  { value: 'military_status_ams', label: 'Active Military Service' },
  { value: 'military_status_veteran', label: 'Veteran' },
  { value: 'military_status_ds', label: 'Disabled Veteran' },
  { value: 'military_status_ng', label: 'National Guard' },
  { value: 'military_status_reserve', label: 'Reserve' },
  { value: 'military_status_retiree', label: 'Retiree' },
  { value: 'military_status_dependent', label: 'Dependent' },
  { value: 'military_status_spouse', label: 'Spouse' },
  { value: 'military_status_dov', label: 'Descendant of Veteran' },
];

export const SCHOLARSHIP_DEGREE_LEVEL = [
  { value: 'academic_level_undergraduate', label: 'Undergraduate' },
  { value: 'academic_level_post_graduate', label: 'Post-Graduate' },
  { value: 'academic_level_certificate', label: 'Certificate' },
  { value: 'academic_level_trade_vocational', label: 'Trade/Vocational' },
];

export const SCHOLARSHIP_EDUCATION_STATUS = [
  { value: 'academic_status_high_school', label: 'High School' },
  {
    value: 'academic_status_student_undergraduate',
    label: 'Returning Adult Student - Undergraduate',
  },
  {
    value: 'academic_status_student_graduate',
    label: 'Returning Adult Student - Graduate',
  },
  { value: 'academic_status_other', label: 'Other' },
];

export const APP_MILITARY_STATUS = [
  { value: 'military_status_ams', label: 'Active' },
  { value: 'military_status_veteran', label: 'Veteran' },
  { value: 'military_status_ng', label: 'Guard' },
  { value: 'military_status_reserve', label: 'Reserve' },
  { value: 'military_status_retiree', label: 'Retired' },
  { value: 'military_status_dependent', label: 'Dependent' },
  { value: 'military_status_spouse', label: 'Spouse' },
];

export const APP_DEGREE_LEVEL = [
  { value: 'academic_level_undergraduate', id: 5 },
  { value: 'academic_level_post_graduate', id: 7 },
  { value: 'academic_level_post_graduate', id: 17 },
  { value: 'academic_level_certificate', id: 18 },
  { value: 'academic_level_trade_vocational', id: 3 },
];

export const APP_SCHOLARSHIP_ORDER = [
  { value: 'a-z', label: 'Alphabetic A - Z' },
  { value: 'z-a', label: 'Alphabetic Z - A' },
  { value: 'open-date', label: 'Open Date' },
  { value: 'deadline-date', label: 'Deadline Date' },
  { value: 'award', label: 'Award Amount' },
];

export const HIGHEST_LEVEL_OPTIONS = [
  { label: 'High School', value: '0' },
  { label: 'Some College', value: '1' },
  { label: "Associate's Degree", value: '2' },
  { label: "Bachelor's Degree", value: '3' },
  { label: "Master's Degree", value: '4' },
  { label: 'Doctorate', value: '5' },
];

export const DASHBOARD_GUIDES_DISABLED_VETERAN = [
  //Disabled Veterans
  {
    name: 'Forms to Apply for VA Disability',
    url: 'https://mymilitarybenefits.com/benefits/forms-to-apply-va-disability/',
  },
  {
    name: 'How to Apply for VA Disability Benefits',
    url: 'https://mymilitarybenefits.com/benefits/applying-va-disability-benefits/',
  },
  {
    name: 'How to File VA Disability Claims',
    url: 'https://mymilitarybenefits.com/benefits/file-va-disability-claims/',
  },
  {
    name: 'How to Apply for VA Disability Increase',
    url: 'https://mymilitarybenefits.com/benefits/how-to-file-for-a-va-disability-increase/',
  },
  {
    name: 'Mistakes to Avoid on VA Claims',
    url: 'https://mymilitarybenefits.com/benefits/how-to-avoid-mistakes-when-claiming-va-disability-benefits/',
  },
  {
    name: 'VA Disability Benefits Eligibility',
    url: 'https://mymilitarybenefits.com/benefits/eligibility-va-disability-benefits/',
  },
  {
    name: 'VA Disability Pay Rates',
    url: 'https://mymilitarybenefits.com/benefits/va-disability-pay/',
  },
  {
    name: 'Federal Resources for New Disabled Veterans',
    url: 'https://mymilitarybenefits.com/benefits/important-federal-resources-for-new-disabled-veterans/',
  },
  {
    name: 'Education Benefits Disabled Vets',
    url: 'https://mymilitarybenefits.com/education/education-benefits-for-disabled-veterans/',
  },
];

export const BENEFIT_VA_LOAN_DISABLED_VETERAN = [
  {
    name: 'TRA Grant for Disabled Vetereans',
    url: 'https://mymilitarybenefits.com/benefits/va-temporary-residence-adaptation-tra-grant-for-disabled-veterans/',
  },
  {
    name: 'VA Loan Funding Fee Exemptions for Disabled Veterans',
    url: 'https://mymilitarybenefits.com/finance/va-loan-funding-fee-exemptions-for-disabled-veterans/',
  },
  {
    name: 'VA Expands Housing Grants for Disabled Veterans',
    url: 'https://mymilitarybenefits.com/benefits/va-expands-housing-grants-for-disabled-veterans/',
  },
  {
    name: 'VA Loan Funding Fee Exemptions for Disabled Vets',
    url: 'https://mymilitarybenefits.com/finance/va-loan-funding-fee-exemptions-for-disabled-veterans/',
  },
  {
    name: 'VA Housing Grants',
    url: 'https://mymilitarybenefits.com/benefits/va-expands-housing-grants-for-disabled-veterans/',
  },
  {
    name: 'TRA GRANT for disabled vets',
    url: 'https://mymilitarybenefits.com/benefits/va-temporary-residence-adaptation-tra-grant-for-disabled-veterans/',
  },
];
